function updatePreview(field, value) {
    if (field === 'title') {
        document.getElementById('notification-title').textContent = renderPushTextPreview(value);
    } else if (field === 'description') {
        document.getElementById('notification-description').textContent = renderPushTextPreview(value);
    } else if (field === 'image') {
        const img = document.getElementById('notification-image');
        const imageBlock = document.getElementById('notification-image-block');
        if (value) {
            img.alt = 'Imagem';
            img.src = value;
            imageBlock?.classList.remove('is-empty');
        } else {
            img.removeAttribute('alt');
            img.removeAttribute('src');
            imageBlock?.classList.add('is-empty');
        }
    } else if (field === 'button') {
        const buttonText = String(value || '').trim();
        const actionBlock = document.getElementById('notification-action-block');
        const actionLink = document.getElementById('notification-action-link');

        if (!actionLink) return;

        if (buttonText) {
            actionLink.textContent = buttonText;
            actionLink.classList.add('is-visible');
            actionBlock?.classList.remove('is-empty');
        } else {
            actionLink.textContent = '';
            actionLink.classList.remove('is-visible');
            actionBlock?.classList.add('is-empty');
        }
    }
}

function applyCalendarEventImage(fieldValue, previewValue = fieldValue) {
    const imageInput = document.getElementById('event-image');
    if (imageInput) {
        imageInput.value = fieldValue || '';
    }

    updatePreview('image', previewValue || '');
}

const PUSH_PERSONALIZATION_DEFAULT_FALLBACK = 'cliente';
const PUSH_PERSONALIZATION_MIN_APP_VERSION = 260404;
const PUSH_PERSONALIZATION_UPGRADE_MESSAGE = 'Solicite atualização do seu app pra usar essa função';
const PUSH_PERSONALIZATION_PREVIEW_LABEL = 'Texto que vai entrar no campo (não alterar)';
const PUSH_PERSONALIZATION_UPGRADE_LABEL = 'Atualização necessária';
const PUSH_PERSONALIZATION_INSERT_LABEL = 'Inserir nome';
const PUSH_PERSONALIZATION_UPGRADE_CTA = 'Solicitar atualização';
const PUSH_PERSONALIZATION_ANY_REGEX = /\{\{\s*(?:nome|first_name)(?:\s*\|\s*(?:padr(?:ã|a)o|fallback|default):\s*'((?:\\.|[^'\\])*)')?\s*\}\}/gi;

function getPushPersonalizationAppVersion() {
    const rawValue = window.localStorage?.getItem('appVersion') || '0';
    const parsedValue = Number.parseInt(rawValue, 10);
    return Number.isFinite(parsedValue) ? parsedValue : 0;
}

function isPushPersonalizationSupported() {
    return getPushPersonalizationAppVersion() >= PUSH_PERSONALIZATION_MIN_APP_VERSION;
}

function warnPushPersonalizationUpgrade() {
    const whatsappLink = String(
        window.pushPersonalizationUpgradeWhatsappLink ||
        'https://api.whatsapp.com/send?phone=5511940396630&text=Ol%C3%A1!%20Quero%20atualizar%20meu%20app%20para%20usar%20personaliza%C3%A7%C3%A3o%20de%20nome%20nos%20pushs.'
    ).replace(/&amp;/g, '&');

    const popup = window.open(whatsappLink, '_blank');
    if (popup) {
        popup.opener = null;
        popup.focus?.();
    }
}

function normalizePushPersonalizationFallback(value) {
    const text = String(value || '').trim();
    return text || PUSH_PERSONALIZATION_DEFAULT_FALLBACK;
}

function escapePushPersonalizationFallback(value) {
    return String(value || '')
        .replace(/\\/g, '\\\\')
        .replace(/'/g, "\\'");
}

function decodePushPersonalizationFallback(value) {
    return String(value || '').replace(/\\(.)/g, '$1');
}

function buildEditorFirstNameToken(fallback = PUSH_PERSONALIZATION_DEFAULT_FALLBACK) {
    const safeFallback = escapePushPersonalizationFallback(normalizePushPersonalizationFallback(fallback));
    return `{{ nome | padrão: '${safeFallback}' }}`;
}

function buildRawFirstNameToken(fallback = PUSH_PERSONALIZATION_DEFAULT_FALLBACK) {
    const safeFallback = escapePushPersonalizationFallback(normalizePushPersonalizationFallback(fallback));
    return `{{ first_name | default: '${safeFallback}' }}`;
}

function toEditorPushText(value) {
    return String(value || '').replace(PUSH_PERSONALIZATION_ANY_REGEX, (_, fallback) => {
        return buildEditorFirstNameToken(decodePushPersonalizationFallback(fallback));
    });
}

function serializePushTextPersonalization(value) {
    return String(value || '').replace(PUSH_PERSONALIZATION_ANY_REGEX, (_, fallback) => {
        return buildRawFirstNameToken(decodePushPersonalizationFallback(fallback));
    });
}

function renderPushTextPreview(value) {
    return String(value || '').replace(PUSH_PERSONALIZATION_ANY_REGEX, (_, fallback) => {
        return normalizePushPersonalizationFallback(decodePushPersonalizationFallback(fallback));
    });
}

function getPushTextPersonalizationMeta(value) {
    const matches = [];
    const source = String(value || '');
    const tokenRegex = /\{\{\s*(?:nome|first_name)(?:\s*\|\s*(?:padr(?:ã|a)o|fallback|default):\s*'((?:\\.|[^'\\])*)')?\s*\}\}/gi;

    let match;
    while ((match = tokenRegex.exec(source)) !== null) {
        matches.push({
            key: 'first_name',
            label: 'nome',
            fallback: normalizePushPersonalizationFallback(decodePushPersonalizationFallback(match[1])),
        });
    }

    return matches;
}

function insertTextAtCursor(input, text) {
    if (!input) return;

    const value = String(input.value || '');
    const start = Number.isFinite(input.selectionStart) ? input.selectionStart : value.length;
    const end = Number.isFinite(input.selectionEnd) ? input.selectionEnd : value.length;

    input.value = `${value.slice(0, start)}${text}${value.slice(end)}`;

    const caret = start + text.length;
    input.focus();
    if (typeof input.setSelectionRange === 'function') {
        input.setSelectionRange(caret, caret);
    }
    input.dispatchEvent(new Event('input', { bubbles: true }));
}

function updatePushPersonalizationPreview(inputId) {
    const fallbackInput = document.getElementById(`${inputId}-personalization-fallback`);
    const preview = document.getElementById(`${inputId}-personalization-preview`);
    const previewWrap = preview?.closest('.personalization-menu__preview');
    const previewLabel = previewWrap?.querySelector('span');
    const insertButton = document.querySelector(`[data-personalization-insert="${inputId}"]`);
    if (!preview) return;

    const isSupported = isPushPersonalizationSupported();
    previewWrap?.classList.toggle('is-upgrade-required', !isSupported);
    preview.classList.toggle('is-upgrade-message', !isSupported);

    if (previewLabel) {
        previewLabel.textContent = isSupported ? PUSH_PERSONALIZATION_PREVIEW_LABEL : PUSH_PERSONALIZATION_UPGRADE_LABEL;
    }

    if (insertButton) {
        insertButton.textContent = isSupported ? PUSH_PERSONALIZATION_INSERT_LABEL : PUSH_PERSONALIZATION_UPGRADE_CTA;
    }

    fallbackInput?.toggleAttribute('disabled', !isSupported);

    if (!isSupported) {
        preview.textContent = PUSH_PERSONALIZATION_UPGRADE_MESSAGE;
        return;
    }

    preview.textContent = buildEditorFirstNameToken(fallbackInput ? fallbackInput.value : PUSH_PERSONALIZATION_DEFAULT_FALLBACK);
}

function syncPushPersonalizationStatus(inputId) {
    const input = document.getElementById(inputId);
    const status = document.getElementById(`${inputId}-personalization-status`);
    if (!input || !status) return;

    const meta = getPushTextPersonalizationMeta(input.value);
    if (!meta.length) {
        status.innerHTML = '';
        status.hidden = true;
        return;
    }

    status.innerHTML = meta.map((item) => {
        return `<span class="personalization-status__pill"><strong>Nome</strong> alternativa: ${escapeHtml(item.fallback)}</span>`;
    }).join('');
    status.hidden = false;
}

function closePushPersonalizationMenus(exceptInputId = null) {
    document.querySelectorAll('.personalization-menu').forEach((menu) => {
        const inputId = menu.id.replace('-personalization-menu', '');
        const shouldStayOpen = exceptInputId && inputId === exceptInputId;
        const trigger = document.querySelector(`[data-personalization-trigger="${inputId}"]`);
        const field = menu.closest('[data-personalization-field]');

        menu.hidden = shouldStayOpen ? false : true;
        if (trigger) {
            trigger.setAttribute('aria-expanded', shouldStayOpen ? 'true' : 'false');
        }
        field?.classList.toggle('is-personalization-open', Boolean(shouldStayOpen));
    });
}

function togglePushPersonalizationMenu(inputId) {
    const menu = document.getElementById(`${inputId}-personalization-menu`);
    const trigger = document.querySelector(`[data-personalization-trigger="${inputId}"]`);
    const fallbackInput = document.getElementById(`${inputId}-personalization-fallback`);
    const insertButton = document.querySelector(`[data-personalization-insert="${inputId}"]`);
    const field = menu?.closest('[data-personalization-field]');
    if (!menu || !trigger) return;

    const shouldOpen = menu.hidden;
    closePushPersonalizationMenus(shouldOpen ? inputId : null);
    menu.hidden = !shouldOpen;
    trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    field?.classList.toggle('is-personalization-open', shouldOpen);

    if (shouldOpen) {
        updatePushPersonalizationPreview(inputId);
        setTimeout(() => {
            if (!isPushPersonalizationSupported()) {
                insertButton?.focus();
                return;
            }
            fallbackInput?.focus();
            fallbackInput?.select?.();
        }, 0);
    }
}

function insertPushPersonalizationToken(inputId) {
    if (!isPushPersonalizationSupported()) {
        warnPushPersonalizationUpgrade();
        return;
    }

    const input = document.getElementById(inputId);
    const fallbackInput = document.getElementById(`${inputId}-personalization-fallback`);
    if (!input) return;

    const token = buildEditorFirstNameToken(fallbackInput ? fallbackInput.value : PUSH_PERSONALIZATION_DEFAULT_FALLBACK);
    insertTextAtCursor(input, token);
    syncPushPersonalizationStatus(inputId);
    closePushPersonalizationMenus();
}

function initPushPersonalizationControls() {
    if (document.body.dataset.pushPersonalizationReady === '1') return;

    const triggers = document.querySelectorAll('[data-personalization-trigger]');
    if (!triggers.length) return;

    document.body.dataset.pushPersonalizationReady = '1';

    triggers.forEach((trigger) => {
        const inputId = trigger.getAttribute('data-personalization-trigger');
        const input = document.getElementById(inputId);
        const fallbackInput = document.getElementById(`${inputId}-personalization-fallback`);
        const insertButton = document.querySelector(`[data-personalization-insert="${inputId}"]`);
        const closeButton = document.querySelector(`[data-personalization-close="${inputId}"]`);

        updatePushPersonalizationPreview(inputId);

        trigger.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            togglePushPersonalizationMenu(inputId);
        });

        fallbackInput?.addEventListener('input', () => updatePushPersonalizationPreview(inputId));
        fallbackInput?.addEventListener('click', (event) => event.stopPropagation());
        fallbackInput?.addEventListener('keydown', (event) => event.stopPropagation());

        insertButton?.addEventListener('click', (event) => {
            event.preventDefault();
            insertPushPersonalizationToken(inputId);
        });

        closeButton?.addEventListener('click', (event) => {
            event.preventDefault();
            closePushPersonalizationMenus();
        });

        if (input) {
            input.value = toEditorPushText(input.value);
            input.addEventListener('input', () => syncPushPersonalizationStatus(inputId));
            input.addEventListener('blur', () => {
                const editorValue = toEditorPushText(input.value);
                if (editorValue !== input.value) {
                    input.value = editorValue;
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                    return;
                }
                syncPushPersonalizationStatus(inputId);
            });
            syncPushPersonalizationStatus(inputId);
        }
    });

    document.addEventListener('click', (event) => {
        if (event.target.closest('[data-personalization-field]')) return;
        closePushPersonalizationMenus();
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closePushPersonalizationMenus();
        }
    });
}

window.renderPushTextPreview = renderPushTextPreview;
window.serializePushTextPersonalization = serializePushTextPersonalization;
window.getPushTextPersonalizationMeta = getPushTextPersonalizationMeta;
window.toEditorPushText = toEditorPushText;
window.initPushPersonalizationControls = initPushPersonalizationControls;
window.isPushPersonalizationSupported = isPushPersonalizationSupported;
window.applyCalendarEventImage = applyCalendarEventImage;

const EVENT_PUSH_LANGUAGES = Object.freeze([
    { code: 'pt', label: 'Português' },
    { code: 'en', label: 'Inglês' },
    { code: 'es', label: 'Espanhol' },
    { code: 'de', label: 'Alemão' },
    { code: 'fr', label: 'Francês' },
    { code: 'it', label: 'Italiano' },
    { code: 'nb', label: 'Norueguês' },
    { code: 'nl', label: 'Holandês' },
    { code: 'ja', label: 'Japonês' },
    { code: 'sv', label: 'Sueco' },
]);

let eventLanguageState = null;

function normalizeEventLanguageCode(value) {
    const normalized = String(value || '').trim().replace(/_/g, '-').toLowerCase();
    if (!normalized) return null;

    const exactMatch = EVENT_PUSH_LANGUAGES.find((language) => language.code.toLowerCase() === normalized);
    if (exactMatch) return exactMatch.code;

    const baseLanguage = normalized.split('-')[0];
    if (baseLanguage === 'no') return 'nb';
    return EVENT_PUSH_LANGUAGES.some((language) => language.code === baseLanguage)
        ? baseLanguage
        : null;
}

function getEventLanguageLabel(code) {
    return EVENT_PUSH_LANGUAGES.find((language) => language.code === code)?.label || String(code || '').toUpperCase();
}

function getConfiguredEventDefaultLanguage() {
    return normalizeEventLanguageCode(window.localStorage?.getItem('appLang')) || 'pt';
}

function captureActiveEventLanguageDraft() {
    if (!eventLanguageState?.activeLanguage) return;

    const titleInput = document.getElementById('event-title');
    const descriptionInput = document.getElementById('event-description');
    const titleFallbackInput = document.getElementById('event-title-personalization-fallback');
    const descriptionFallbackInput = document.getElementById('event-description-personalization-fallback');
    if (!titleInput || !descriptionInput) return;

    eventLanguageState.texts[eventLanguageState.activeLanguage] = {
        title: String(titleInput.value || ''),
        description: String(descriptionInput.value || ''),
        titleFallback: normalizePushPersonalizationFallback(titleFallbackInput?.value),
        descriptionFallback: normalizePushPersonalizationFallback(descriptionFallbackInput?.value),
    };
}

function renderEventLanguageSettings() {
    if (!eventLanguageState) return;

    const selectedLanguages = eventLanguageState.languages;
    const selectedSet = new Set(selectedLanguages);
    const list = document.getElementById('multiLangList');
    const picker = document.getElementById('event-language-picker');
    const addButton = document.getElementById('addLanguageBtn');

    if (list) {
        list.innerHTML = selectedLanguages.map((code) => {
            const label = getEventLanguageLabel(code);
            const isDefault = code === eventLanguageState.defaultLanguage;
            const action = isDefault
                ? '<span class="badge bg-light text-muted">Padrão</span>'
                : `<button type="button" class="btn btn-sm btn-icon btn-outline-light event-language-list__remove" data-remove-event-language="${code}" aria-label="Remover ${escapeHtml(label)}"><em class="icon ni ni-cross"></em></button>`;

            return `<li class="event-language-list__item" data-event-language-item="${code}"><span>${escapeHtml(label)}</span>${action}</li>`;
        }).join('');
    }

    if (picker) {
        const availableLanguages = EVENT_PUSH_LANGUAGES.filter((language) => !selectedSet.has(language.code));
        Array.from(picker.options).forEach((option) => {
            const isSelected = selectedSet.has(option.value);
            option.disabled = isSelected;
            option.hidden = isSelected;
        });

        picker.disabled = availableLanguages.length === 0;
        picker.value = availableLanguages[0]?.code || '';
        if (addButton) addButton.disabled = availableLanguages.length === 0;
    }

}

function renderEventLanguageCarousel() {
    if (!eventLanguageState) return;

    const carousel = document.getElementById('eventLanguageCarousel');
    const controls = document.getElementById('eventLanguageCarouselControls');
    const indicators = document.getElementById('eventLanguageIndicators');
    const currentLabel = document.getElementById('eventLanguageCurrentLabel');
    const position = document.getElementById('eventLanguagePosition');
    const isMultilingual = eventLanguageState.languages.length > 1;
    const activeIndex = Math.max(0, eventLanguageState.languages.indexOf(eventLanguageState.activeLanguage));

    carousel?.classList.toggle('is-multilingual', isMultilingual);
    if (controls) controls.hidden = !isMultilingual;
    if (indicators) {
        indicators.hidden = !isMultilingual;
        indicators.innerHTML = isMultilingual
            ? eventLanguageState.languages.map((code) => {
                const label = getEventLanguageLabel(code);
                const isActive = code === eventLanguageState.activeLanguage;
                return `<button type="button" class="event-language-carousel__indicator${isActive ? ' is-active' : ''}" data-show-event-language="${code}" aria-label="Editar textos em ${escapeHtml(label)}" aria-current="${isActive ? 'true' : 'false'}">${escapeHtml(code.toUpperCase())}</button>`;
            }).join('')
            : '';
    }
    if (currentLabel) currentLabel.textContent = getEventLanguageLabel(eventLanguageState.activeLanguage);
    if (position) position.textContent = `${activeIndex + 1} de ${eventLanguageState.languages.length}`;

    renderEventLanguageSettings();
}

function loadActiveEventLanguageDraft(direction = null) {
    if (!eventLanguageState?.activeLanguage) return;

    const titleInput = document.getElementById('event-title');
    const descriptionInput = document.getElementById('event-description');
    const titleFallbackInput = document.getElementById('event-title-personalization-fallback');
    const descriptionFallbackInput = document.getElementById('event-description-personalization-fallback');
    const fields = document.getElementById('eventLanguageFields');
    const draft = eventLanguageState.texts[eventLanguageState.activeLanguage] || {
        title: '',
        description: '',
        titleFallback: PUSH_PERSONALIZATION_DEFAULT_FALLBACK,
        descriptionFallback: PUSH_PERSONALIZATION_DEFAULT_FALLBACK,
    };
    if (!titleInput || !descriptionInput) return;

    closePushPersonalizationMenus();
    titleInput.value = toEditorPushText(draft.title);
    descriptionInput.value = toEditorPushText(draft.description);
    if (titleFallbackInput) titleFallbackInput.value = normalizePushPersonalizationFallback(draft.titleFallback);
    if (descriptionFallbackInput) descriptionFallbackInput.value = normalizePushPersonalizationFallback(draft.descriptionFallback);
    updatePushPersonalizationPreview('event-title');
    updatePushPersonalizationPreview('event-description');
    updatePreview('title', titleInput.value || 'Título da Notificação');
    updatePreview('description', descriptionInput.value || 'Descrição...');
    syncPushPersonalizationStatus('event-title');
    syncPushPersonalizationStatus('event-description');

    if (fields && direction) {
        fields.classList.remove('is-sliding-next', 'is-sliding-previous');
        void fields.offsetWidth;
        fields.classList.add(direction === 'previous' ? 'is-sliding-previous' : 'is-sliding-next');
    }
}

function showEventLanguage(code, direction = null) {
    const normalizedCode = normalizeEventLanguageCode(code);
    if (!eventLanguageState || !normalizedCode || !eventLanguageState.languages.includes(normalizedCode)) return false;
    if (normalizedCode === eventLanguageState.activeLanguage) return true;

    const currentIndex = eventLanguageState.languages.indexOf(eventLanguageState.activeLanguage);
    const nextIndex = eventLanguageState.languages.indexOf(normalizedCode);
    captureActiveEventLanguageDraft();
    eventLanguageState.activeLanguage = normalizedCode;
    renderEventLanguageCarousel();
    loadActiveEventLanguageDraft(direction || (nextIndex < currentIndex ? 'previous' : 'next'));
    return true;
}

function moveEventLanguage(direction) {
    if (!eventLanguageState || eventLanguageState.languages.length < 2) return;

    const currentIndex = eventLanguageState.languages.indexOf(eventLanguageState.activeLanguage);
    const offset = direction === 'previous' ? -1 : 1;
    const nextIndex = (currentIndex + offset + eventLanguageState.languages.length) % eventLanguageState.languages.length;
    showEventLanguage(eventLanguageState.languages[nextIndex], direction);
}

function addEventLanguage(code) {
    const normalizedCode = normalizeEventLanguageCode(code);
    if (!eventLanguageState || !normalizedCode || eventLanguageState.languages.includes(normalizedCode)) return false;

    captureActiveEventLanguageDraft();
    eventLanguageState.languages.push(normalizedCode);
    eventLanguageState.texts[normalizedCode] = {
        title: '',
        description: '',
        titleFallback: PUSH_PERSONALIZATION_DEFAULT_FALLBACK,
        descriptionFallback: PUSH_PERSONALIZATION_DEFAULT_FALLBACK,
    };
    eventLanguageState.activeLanguage = normalizedCode;
    renderEventLanguageCarousel();
    loadActiveEventLanguageDraft('next');
    document.getElementById('event-title')?.focus();
    return true;
}

function removeEventLanguage(code) {
    const normalizedCode = normalizeEventLanguageCode(code);
    if (!eventLanguageState || !normalizedCode || normalizedCode === eventLanguageState.defaultLanguage) return false;
    if (!eventLanguageState.languages.includes(normalizedCode)) return false;

    captureActiveEventLanguageDraft();
    eventLanguageState.languages = eventLanguageState.languages.filter((language) => language !== normalizedCode);
    delete eventLanguageState.texts[normalizedCode];

    const removedActiveLanguage = eventLanguageState.activeLanguage === normalizedCode;
    if (removedActiveLanguage) eventLanguageState.activeLanguage = eventLanguageState.defaultLanguage;
    renderEventLanguageCarousel();
    if (removedActiveLanguage) loadActiveEventLanguageDraft('previous');
    return true;
}

function normalizeEventLanguageCollection(value) {
    const source = Array.isArray(value) ? value : [];
    return Array.from(new Set(source.map(normalizeEventLanguageCode).filter(Boolean)));
}

function setEventLanguagePayload(payload = {}) {
    const headings = normalizeLocalizedPushTextMap(payload.headings);
    const contents = normalizeLocalizedPushTextMap(payload.contents);
    const requestedDefault = normalizeEventLanguageCode(payload.defaultLanguage);
    const requestedLanguages = normalizeEventLanguageCollection(payload.languages);
    const inferredLanguages = normalizeEventLanguageCollection([
        ...Object.keys(headings),
        ...Object.keys(contents),
    ]);
    const inferredDefault = inferredLanguages.find((code) => code !== 'en') || inferredLanguages[0] || null;
    const defaultLanguage = requestedDefault || inferredDefault || getConfiguredEventDefaultLanguage();
    const englishMirrorsDefault = defaultLanguage !== 'en' &&
        Object.prototype.hasOwnProperty.call(headings, 'en') &&
        Object.prototype.hasOwnProperty.call(contents, 'en') &&
        headings.en === (headings[defaultLanguage] ?? payload.title ?? '') &&
        contents.en === (contents[defaultLanguage] ?? payload.description ?? '');
    const inferredSelectedLanguages = inferredLanguages.filter((code) => code !== 'en' || !englishMirrorsDefault);
    const languages = requestedLanguages.length
        ? requestedLanguages
        : (inferredSelectedLanguages.length ? inferredSelectedLanguages : [defaultLanguage]);
    if (!languages.includes(defaultLanguage)) languages.unshift(defaultLanguage);

    const orderedLanguages = [defaultLanguage, ...languages.filter((code) => code !== defaultLanguage)];
    const texts = {};
    orderedLanguages.forEach((code) => {
        const isDefault = code === defaultLanguage;
        const title = toEditorPushText(headings[code] ?? (isDefault ? payload.title : '') ?? '');
        const description = toEditorPushText(contents[code] ?? (isDefault ? payload.description : '') ?? '');
        texts[code] = {
            title,
            description,
            titleFallback: getPushTextPersonalizationMeta(title)[0]?.fallback || PUSH_PERSONALIZATION_DEFAULT_FALLBACK,
            descriptionFallback: getPushTextPersonalizationMeta(description)[0]?.fallback || PUSH_PERSONALIZATION_DEFAULT_FALLBACK,
        };
    });

    eventLanguageState = {
        defaultLanguage,
        activeLanguage: defaultLanguage,
        languages: orderedLanguages,
        texts,
    };

    renderEventLanguageCarousel();
    loadActiveEventLanguageDraft();
}

function resetEventLanguageControls(payload = {}) {
    setEventLanguagePayload(payload);
}

function syncEventDefaultLanguageFromConfig() {
    if (!eventLanguageState) return false;

    const configuredLanguage = getConfiguredEventDefaultLanguage();
    if (configuredLanguage === eventLanguageState.defaultLanguage) return false;

    captureActiveEventLanguageDraft();
    const hasDraft = eventLanguageState.languages.some((code) => {
        const draft = eventLanguageState.texts[code] || {};
        return String(draft.title || '').trim() || String(draft.description || '').trim();
    });
    if (eventLanguageState.languages.length > 1 || hasDraft) return false;

    setEventLanguagePayload({ defaultLanguage: configuredLanguage });
    return true;
}

function getEventLanguagePayload() {
    if (!eventLanguageState) {
        setEventLanguagePayload({
            title: document.getElementById('event-title')?.value || '',
            description: document.getElementById('event-description')?.value || '',
        });
    }
    captureActiveEventLanguageDraft();

    const defaultLanguage = eventLanguageState.defaultLanguage;
    const languages = [...eventLanguageState.languages];
    const localizedHeadings = {};
    const localizedContents = {};
    const previews = [];
    const missingLanguages = [];

    languages.forEach((code) => {
        const draft = eventLanguageState.texts[code] || { title: '', description: '' };
        const title = String(draft.title || '');
        const description = String(draft.description || '');
        const missingFields = [];
        if (!title.trim()) missingFields.push('title');
        if (!description.trim()) missingFields.push('description');
        if (missingFields.length) missingLanguages.push({ code, label: getEventLanguageLabel(code), fields: missingFields });

        localizedHeadings[code] = serializePushTextPersonalization(title);
        localizedContents[code] = serializePushTextPersonalization(description);
        previews.push({
            code,
            label: getEventLanguageLabel(code),
            title: renderPushTextPreview(title),
            description: renderPushTextPreview(description),
        });
    });

    const defaultTitle = localizedHeadings[defaultLanguage] || '';
    const defaultDescription = localizedContents[defaultLanguage] || '';
    const headings = { en: localizedHeadings.en || defaultTitle };
    const contents = { en: localizedContents.en || defaultDescription };
    languages.forEach((code) => {
        headings[code] = localizedHeadings[code];
        contents[code] = localizedContents[code];
    });

    return {
        title: defaultTitle,
        description: defaultDescription,
        headings,
        contents,
        defaultLanguage,
        languages,
        previews,
        missingLanguages,
        hasPersonalization: languages.some((code) => {
            const draft = eventLanguageState.texts[code] || {};
            return getPushTextPersonalizationMeta(draft.title).length > 0 ||
                getPushTextPersonalizationMeta(draft.description).length > 0;
        }),
    };
}

function focusEventLanguageField(code, field = 'title') {
    if (!showEventLanguage(code)) return;
    const input = document.getElementById(field === 'description' ? 'event-description' : 'event-title');
    if (!input) return;
    input.style.boxShadow = '0 0 5px red';
    input.focus();
}

function buildEventLanguageReviewHtml(payload) {
    const items = Array.isArray(payload?.previews) ? payload.previews : [];
    if (items.length <= 1) {
        const item = items[0] || { title: '', description: '' };
        return `Título: <b>${escapeHtml(item.title)}</b><br><br>Descrição: <b>${escapeHtml(item.description)}</b><br><br>`;
    }

    return `<div style="margin-bottom:14px"><strong>Textos por idioma:</strong>${items.map((item) => `
        <div style="margin-top:10px; padding:10px 12px; border:1px solid rgba(82,100,132,.18); border-radius:10px">
            <strong>${escapeHtml(item.label)}</strong><br>
            Título: <b>${escapeHtml(item.title)}</b><br>
            Descrição: <b>${escapeHtml(item.description)}</b>
        </div>`).join('')}</div>`;
}

function initEventLanguageControls() {
    const carousel = document.getElementById('eventLanguageCarousel');
    if (!carousel || carousel.dataset.languageControlsReady === '1') return;
    carousel.dataset.languageControlsReady = '1';

    const initialTitle = document.getElementById('event-title')?.value || '';
    const initialDescription = document.getElementById('event-description')?.value || '';
    setEventLanguagePayload({ title: initialTitle, description: initialDescription });

    document.getElementById('addLanguageBtn')?.addEventListener('click', () => {
        addEventLanguage(document.getElementById('event-language-picker')?.value);
    });
    document.getElementById('multiLangList')?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-remove-event-language]');
        if (button) removeEventLanguage(button.dataset.removeEventLanguage);
    });
    document.getElementById('eventLanguagePrevious')?.addEventListener('click', () => moveEventLanguage('previous'));
    document.getElementById('eventLanguageNext')?.addEventListener('click', () => moveEventLanguage('next'));
    document.getElementById('eventLanguageIndicators')?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-show-event-language]');
        if (button) showEventLanguage(button.dataset.showEventLanguage);
    });
    document.getElementById('event-title')?.addEventListener('input', captureActiveEventLanguageDraft);
    document.getElementById('event-description')?.addEventListener('input', captureActiveEventLanguageDraft);
    document.getElementById('addEventPopup')?.addEventListener('show.bs.modal', syncEventDefaultLanguageFromConfig);
}

window.EVENT_PUSH_LANGUAGES = EVENT_PUSH_LANGUAGES;
window.getEventLanguagePayload = getEventLanguagePayload;
window.setEventLanguagePayload = setEventLanguagePayload;
window.resetEventLanguageControls = resetEventLanguageControls;
window.focusEventLanguageField = focusEventLanguageField;
window.buildEventLanguageReviewHtml = buildEventLanguageReviewHtml;
window.addEventListener('foxappy:app-language-changed', syncEventDefaultLanguageFromConfig);

function updateEmailPreview(field, value) {
    if (field === 'title') {
        document.getElementById('preview-title').textContent = value;
    } else if (field === 'description') {
        document.getElementById('preview-description').textContent = value;
    } else if (field === 'date') {
        document.getElementById('preview-date').textContent = value;
    } else if (field === 'time') {
        document.getElementById('preview-time').textContent = value;
    } else if (field === 'image' && value) {
        if (isValidUrl(value)) {
            const imgEmailBody = document.getElementById('imageTemplate');
            if (imgEmailBody) {
                imgEmailBody.src = value;
            } else {
                document.getElementById('preview-template').innerHTML =
                    `<img id="imageTemplate" src="${value}" style="width:100%" />`;
            }
        } else {
            document.getElementById('preview-template').textContent = 'Link da imagem inválido';
        }
    }
}

let db, limit = $('.nk-block-head-sm').attr('id') === 'starter' ? 15 : 50;

function pad2(n) {
    return String(n).padStart(2, '0');
}

function brDateToYmd(dateStr) {
    if (!dateStr) return '';
    const s = String(dateStr).trim();

    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;

    const parts = s.split('/');
    if (parts.length !== 3) return s;

    const [dd, mm, yyyy] = parts;
    return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
}

function getMonthKeyFromDate(dateObj) {
    const d = dateObj instanceof Date ? dateObj : new Date(dateObj);
    return `${pad2(d.getMonth() + 1)}-${d.getFullYear()}`;
}

function sleep(ms) {
    return new Promise((r) => setTimeout(r, ms));
}

async function waitForListenPushFn(maxTries = 25, delayMs = 150) {
    for (let i = 0; i < maxTries; i++) {
        if (typeof window.listenPushNotificationsByMonth === 'function')
            return window.listenPushNotificationsByMonth;
        await sleep(delayMs);
    }
    return null;
}

function normalizeHexColor(color) {
    if (!color) return null;
    let c = String(color).trim();
    if (c.startsWith('#')) c = c.slice(1);
    c = c.toLowerCase();
    if (c.length === 3) c = c.split('').map((x) => x + x).join('');
    return /^[0-9a-f]{6}$/.test(c) ? c : null;
}

function parseSendAfterToIso(sendAfter) {
    if (!sendAfter) return null;
    const s = String(sendAfter).trim();

    const isoOffset = s.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?[+-]\d{2}:\d{2}$/);
    if (isoOffset) return s;

    // 3) ISO Z com fração 1..9 dígitos (normaliza pra 3ms)
    // 2026-01-02T21:46:53.748582Z -> 2026-01-02T21:46:53.748Z
    const isoZ = s.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(?:\.(\d{1,9}))?Z$/i);
    if (isoZ) {
        const base = isoZ[1];
        const frac = isoZ[2] || '';
        const ms = (frac + '000').slice(0, 3);
        return ms === '000' ? `${base}Z` : `${base}.${ms}Z`;
    }

    const gmtToOffset = (gmt) => {
        const raw = gmt.toUpperCase().replace('GMT', ''); // -0300
        return raw.slice(0, 3) + ':' + raw.slice(3);     // -03:00
    };

    // 1) "2025-10-15 14:44:21 GMT-0300" (aceita texto extra depois)
    let m = s.match(/^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2})(?::(\d{2}))?\s+(GMT[+-]\d{4})(?:.*)?$/i);
    if (m) {
        const yyyy = m[1], mm = m[2], dd = m[3];
        const HH = m[4], MI = m[5], SS = m[6] || '00';
        const off = gmtToOffset(m[7]);
        return `${yyyy}-${mm}-${dd}T${HH}:${MI}:${SS}${off}`;
    }

    // 2) "30/12/2025 12:29:35 GMT-0300" (aceita texto extra depois)
    m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})(?::(\d{2}))?\s+(GMT[+-]\d{4})(?:.*)?$/i);
    if (m) {
        const dd = m[1], mm = m[2], yyyy = m[3];
        const HH = m[4], MI = m[5], SS = m[6] || '00';
        const off = gmtToOffset(m[7]);
        return `${yyyy}-${mm}-${dd}T${HH}:${MI}:${SS}${off}`;
    }

    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d.toISOString();
}

function escapeHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function resolveNotificationClicks(notification) {
    if (!notification || typeof notification !== 'object') return 0;

    if (Array.isArray(notification.clicks)) {
        return notification.clicks.filter(Boolean).length;
    }

    if (notification.clicks && typeof notification.clicks === 'object') {
        return Object.keys(notification.clicks).filter((key) => notification.clicks[key]).length;
    }

    const directCandidates = [
        notification.converted,
        notification.clicked,
        notification.click_count,
    ];
    for (let i = 0; i < directCandidates.length; i += 1) {
        const value = Number(directCandidates[i]);
        if (Number.isFinite(value) && value >= 0) return value;
    }

    if (notification.platform_delivery_stats && typeof notification.platform_delivery_stats === 'object') {
        return Object.values(notification.platform_delivery_stats).reduce((sum, entry) => {
            if (!entry || typeof entry !== 'object') return sum;
            const converted = Number(entry.converted);
            if (Number.isFinite(converted) && converted > 0) return sum + converted;
            const clicked = Number(entry.clicked);
            if (Number.isFinite(clicked) && clicked > 0) return sum + clicked;
            return sum;
        }, 0);
    }

    return 0;
}

function buildCalendarHoverContent(description, clicks, shouldShowClicks) {
    const safeDesc = escapeHtml(description || 'Sem descrição');
    if (!shouldShowClicks) return safeDesc;

    const clicksCount = Number.isFinite(Number(clicks)) ? Number(clicks) : 0;
    const clicksLabel = clicksCount.toLocaleString('pt-BR');
    return `${safeDesc}<div class="mt-2 text-purple"><em class="icon ni ni-hot-fill"></em><strong> Cliques:</strong> ${clicksLabel}</div>`;
}

// function normalizeText(str) {
//   if (!str) return str;
//   let result = String(str);

//   // 1) Tentar arrumar percent-encoding tipo "%E2%9D%A4"
//   if (/%[0-9A-Fa-f]{2}/.test(result)) {
//     try {
//       // se tiver espaço tratado como "+", normaliza
//       const tmp = result.replace(/\+/g, '%20');
//       const decoded = decodeURIComponent(tmp);
//       if (decoded && decoded !== result) {
//         result = decoded;
//       }
//     } catch (e) {
//       // ignora erro e segue com o texto original
//     }
//   }

//   // 2) Tentar arrumar casos "Ã©", "Ã£", etc. (UTF-8 lido como Latin1)
//   if (/[ÃÂàáâãäçèéêëìíîïñòóôõöùúûü]/.test(result)) {
//     try {
//       // só roda se todos os charCodes < 256 (senão vai dar ruim)
//       let allBelow256 = true;
//       for (let i = 0; i < result.length; i++) {
//         if (result.charCodeAt(i) > 255) {
//           allBelow256 = false;
//           break;
//         }
//       }
//       if (allBelow256 && typeof TextDecoder !== 'undefined') {
//         const bytes = new Uint8Array(result.length);
//         for (let i = 0; i < result.length; i++) {
//           bytes[i] = result.charCodeAt(i);
//         }
//         const decoded = new TextDecoder('utf-8').decode(bytes);
//         if (decoded && decoded.indexOf('�') === -1) {
//           result = decoded;
//         }
//       }
//     } catch (e) {
//       // segue a vida
//     }
//   }

//   // 3) Remendos específicos pros exemplos que você mostrou
//   // (Só entra se a string tiver exatamente esses padrões)
//   result = result
//     .replace(/voc/gi, (m) => (m[0] === 'V' ? 'Você' : 'você'))
//     .replace(/n茅/gi, 'né')
//     .replace(/Ergon么mica/gi, 'Ergonômica')
//     // às vezes vem "=%5% em economia..." – remove esse "=%" lixo
//     .replace(/=%(\d+%)/g, '$1');

//   return result;
// }


const AUTO_FILTER_KEY = 'automaticPushTypes';

// retorna array: ["register","recoverCart","reward"...]
function hasStoredAutoFilter() {
    try { return localStorage.getItem(AUTO_FILTER_KEY) !== null; } catch (e) { return false; }
}

function setAutomaticTypeFilter(arr) {
    try { localStorage.setItem(AUTO_FILTER_KEY, JSON.stringify(arr || [])); } catch (e) { }
}

function getAutomaticTypeFilter() {
    try {
        const raw = localStorage.getItem(AUTO_FILTER_KEY);
        const arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
    } catch (e) {
        return [];
    }
}

function isAllowedAutomaticType(automaticType, selected) {
    if (!automaticType) return false;
    const t = String(automaticType);

    // se nada marcado => NÃO exibe automáticos
    if (!selected || !selected.length) return false;

    // Cashback: automaticType contains 'reward'
    if (selected.includes('reward') && t.includes('reward')) return true;

    // Demais: match exato (register / recoverCart / birthdate etc)
    return selected.includes(t);
}

function setupAutomaticFilterUI() {
    const link = document.getElementById('automaticPushFilterLink');
    const popup = document.getElementById('automaticPushFilterPopup');
    if (!link || !popup) return;

    window.__autoFilterUI = window.__autoFilterUI || {};
    window.__autoFilterUI.updateCounts = (monthData) => {
        const counts = countAutomaticTypes(monthData);
        updatePopupCounts(popup, counts);
    };

    const checkboxes = Array.from(popup.querySelectorAll('input[type="checkbox"][data-auto]'));

    if (!hasStoredAutoFilter()) {
        const defaults = Array.from(new Set(checkboxes.map(cb => cb.dataset.auto)))
            .filter((type) => type !== 'register' && type !== 'recoverCart');
        setAutomaticTypeFilter(defaults);
    }

    function syncUIFromStorage() {
        const selected = getAutomaticTypeFilter();
        checkboxes.forEach(cb => {
            cb.checked = selected.includes(cb.dataset.auto);
        });

        const active = selected.length > 0;
        link.classList.toggle('is-active', active);
        // opcional: mostrar quantidade no texto
        link.textContent = active
            ? `Filtrar pushs automáticos (${selected.length})`
            : 'Filtrar pushs automáticos';
    }

    function emitFilterChanged() {
        window.dispatchEvent(new CustomEvent('calendar:toggleAutomaticPushes', {
            detail: { types: getAutomaticTypeFilter() }
        }));
    }

    // abre/fecha popup
    link.addEventListener('click', (e) => {
        e.preventDefault();
        popup.classList.toggle('show');
    });

    // fecha ao clicar fora
    document.addEventListener('click', (e) => {
        if (!popup.classList.contains('show')) return;
        const target = e.target;
        if (popup.contains(target) || link.contains(target)) return;
        popup.classList.remove('show');
    });

    // mudanças nos checks
    checkboxes.forEach(cb => {
        cb.addEventListener('change', () => {
            const selected = checkboxes.filter(x => x.checked).map(x => x.dataset.auto);
            // remove duplicados (caso rastreio/carrinho repitam)
            const unique = Array.from(new Set(selected));
            setAutomaticTypeFilter(unique);
            syncUIFromStorage();
            emitFilterChanged();
        });
    });

    syncUIFromStorage();
}

function countAutomaticTypes(monthData) {
    const counts = {};
    const entries = monthData ? Object.values(monthData) : [];

    for (const n of entries) {
        const t = n?.data?.automaticType;
        if (!t) continue;

        const s = String(t).trim();
        if (!s) continue;

        counts[s] = (counts[s] || 0) + 1;

        if (s.includes('reward')) {
            counts.reward = (counts.reward || 0) + 1;
        }
    }

    return counts;
}

function updatePopupCounts(popupEl, counts) {
    if (!popupEl) return;

    const labels = popupEl.querySelectorAll('label[data-base]');
    labels.forEach(label => {
        const inputId = label.getAttribute('for');
        const input = inputId ? document.getElementById(inputId) : null;
        const auto = input?.dataset?.auto;

        const c = auto ? (counts[auto] || 0) : 0;
        label.textContent = `${label.dataset.base} (${c})`;
    });
}

function getShowAutomaticPushes() {
    try {
        const v = localStorage.getItem('showAutomaticPushes');
        if (v === null) return true;
        return v === '1' || v === 'true';
    } catch (e) {
        return true;
    }
}

function cssEscapeSafe(v) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(v);
    return String(v).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
}

function resolveSegmentLabel(segmentKey, segmentNameMap = null) {
    if (Array.isArray(segmentKey)) {
        const labels = Array.from(new Set(segmentKey
            .map((key) => resolveSegmentLabel(key, segmentNameMap))
            .filter(Boolean)));
        return labels.length ? labels.join(', ') : 'Não definido';
    }

    const key = (segmentKey || '').trim();
    if (!key) return 'Não definido';
    if (key === 'pushBirthdate') return 'Aniversariante';
    if (key === 'Total Subscriptions') return 'Todos os inscritos';

    if (key.startsWith('userIds')) {
        const sel = document.getElementById('event-segment');

        // 1) tenta pegar pelo <option> do select
        if (sel && sel.options && sel.options.length) {
            const opt = Array.from(sel.options).find(o => (o.value || '').trim() === key);
            if (opt && opt.textContent) {
                const t = opt.textContent.replace(/\s+/g, ' ').trim();
                if (t && t !== key) return t;
            }
        }
        // 2) fallback: pega o mesmo texto que o select2 renderiza (span.fc-<key>)
        const node = document.querySelector(`.fc-${cssEscapeSafe(key)}`);
        if (node) {
            const t = node.textContent.replace(/\s+/g, ' ').trim();
            if (t && t !== key) return t;
        }

        if (segmentNameMap && typeof segmentNameMap === 'object') {
            const t = String(segmentNameMap[key] || '').replace(/\s+/g, ' ').trim();
            if (t && t !== key) return t;
        }
    }
    return key;
}

function buildSegmentNameMap(segmentKeys) {
    const keys = Array.isArray(segmentKeys) ? segmentKeys : [segmentKeys];
    const sel = document.getElementById('event-segment');
    const map = {};

    keys.forEach((segmentKey) => {
        const key = String(segmentKey || '').trim();
        if (!key || !key.startsWith('userIds')) return;

        let label = '';
        if (sel && sel.options && sel.options.length) {
            const opt = Array.from(sel.options).find(o => (o.value || '').trim() === key);
            if (opt && opt.textContent) {
                label = opt.textContent.replace(/\s+/g, ' ').trim();
            }
        }

        if (!label || label === key) {
            label = resolveSegmentLabel(key);
        }
        if (label && label !== key) {
            map[key] = label;
        }
    });

    return Object.keys(map).length ? map : null;
}

function setPreviewSegmentText(label) {
    const el = document.getElementById('preview-event-segment');
    if (!el) return;

    const fullText = String(label || '');
    const shouldTruncate = fullText.length > 80;
    const tooltip = window.bootstrap?.Tooltip?.getInstance(el);
    if (tooltip) tooltip.dispose();

    el.textContent = shouldTruncate ? `${fullText.slice(0, 80).trimEnd()}...` : fullText;
    el.removeAttribute('data-bs-toggle');
    el.removeAttribute('data-bs-placement');
    el.removeAttribute('data-bs-original-title');
    el.removeAttribute('title');
    el.removeAttribute('aria-label');

    if (!shouldTruncate) return;

    el.setAttribute('data-bs-toggle', 'tooltip');
    el.setAttribute('data-bs-placement', 'top');
    el.setAttribute('title', fullText);
    el.setAttribute('aria-label', fullText);
    if (window.bootstrap?.Tooltip) {
        new bootstrap.Tooltip(el);
    }
}

!(function (NioApp, $) {
    "use strict";

    NioApp.Calendar = function () {
        var month = [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
            "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ];

        var calendarEl = document.getElementById('calendar');
        var addEventBtn = $('#addEvent');
        var addEventForm = $('#addEventForm');
        var addEventPopup = $('#addEventPopup');

        var addEmailBtn = $('#addEmail');
        var addEmailForm = $('#addEmailForm');
        var addEmailPopup = $('#addEmailPopup');

        var editEventForm = $('#editEventForm');
        var previewEventPopup = $('#previewEventPopup');
        var resendEventBtn = $('#resendEventBtn');
        var deleteEventBtn = $('#deleteEvent');
        var bulkCancelToggleBtn = $('#bulkCancelToggle');
        var bulkCancelConfirmBtn = $('#bulkCancelConfirm');
        var bulkCancelExitBtn = $('#bulkCancelExit');
        var bulkCancelExecuteBtn = $('#bulkCancelExecute');

        initPushPersonalizationControls();
        initEventLanguageControls();

        var mobileView = (NioApp.Win.width < NioApp.Break.md) ? true : false;

        let colors = {
            'event-primary': '0fac81',
            'event-success': '1ee0ac',
            'event-info': '09c2de',
            'event-warning': 'f4bd0e',
            'event-danger': 'e85347',
            'event-pink': 'ff63a5',
            'event-primary-dim': '9dd9c2',
            'event-success-dim': 'c1feec',
            'event-info-dim': 'c2f2fb',
            'event-warning-dim': 'f1e1b7',
            'event-danger-dim': 'f9c6c1',
            'event-pink-dim': 'ffc8de',
        };

        // ---------------- Db subscription control ----------------
        let currentMonthKey = null;
        const monthDataCache = {};
        const monthEventsCache = {};
        const monthUnsubscribers = {};
        const monthSubscribePending = {};

        var primaryColor = document.getElementById('primaryColor');
        if (primaryColor) {
            const colorReplaced = primaryColor.dataset.color?.replace('#', '');
            colors = { 'event-primaryColor': colorReplaced, ...colors };

            if (!document.getElementById('primary-color-style')) {
                const color = '#' + colorReplaced;
                document.head.insertAdjacentHTML(
                    'beforeend',
                    `<style id="primary-color-style">
                        .fc-event-primaryColor .dot,
                        .fc-event-primaryColor .fc-daygrid-event-dot {
                            background-color: ${color} !important;
                            border-color: ${color} !important;
                        }
                    </style>`
                );
            }
        }

        var defaultColorClass = primaryColor ? 'event-primaryColor' : 'event-primary';

        function mapDbEntryToEvent(id, n, selectedTypes) {
            const startIso = parseSendAfterToIso(n?.sendAfter);
            if (!startIso) return null;

            const automaticType = n?.data?.automaticType || null;
            const isAutomatic = !!automaticType;
            if (isAutomatic && !isAllowedAutomaticType(automaticType, selectedTypes)) return null;

            const localizedHeadings = n?.headings && typeof n.headings === 'object' && !Array.isArray(n.headings)
                ? n.headings
                : null;
            const localizedContents = n?.contents && typeof n.contents === 'object' && !Array.isArray(n.contents)
                ? n.contents
                : null;
            const defaultLanguage = normalizeEventLanguageCode(n?.defaultLanguage) || 'pt';
            const rawTitle = n?.title || localizedHeadings?.[defaultLanguage] || localizedHeadings?.en || localizedHeadings?.pt || 'Sem título';
            const rawDesc = n?.desc || n?.description || localizedContents?.[defaultLanguage] || localizedContents?.en || localizedContents?.pt || 'Sem descrição';
            const title = renderPushTextPreview(rawTitle);
            const desc = renderPushTextPreview(rawDesc);

            const hex = normalizeHexColor(n?.color);
            const hexColor = hex ? `#${hex}` : null;

            const segment =
                n?.eventSegment ||
                (Array.isArray(n?.includePlayers) ? `${n.includePlayers.length} usuário(s)` : 'Não definido');
            const segmentName = (n?.segmentName && typeof n.segmentName === 'object' && !Array.isArray(n.segmentName))
                ? n.segmentName
                : null;

            return {
                id,
                title: (n?.canceled ? '[Cancelado] ' : '') + title,
                start: startIso,
                className: `fc-${defaultColorClass}`,
                description: desc,
                rawTitle,
                rawDescription: rawDesc,
                headings: localizedHeadings,
                contents: localizedContents,
                defaultLanguage,
                languages: normalizeEventLanguageCollection(n?.languages),
                image: n?.image || 'Sem imagem',
                pageUrl: n?.url || 'Sem link - abre o app na página inicial',
                buttonText: n?.buttonText || n?.buttons?.[0]?.text || '',
                segment,
                segmentName,
                isEmail: !!n?.isEmail,
                trackingCode: n?.data?.trackingNumber || null,
                codigo: n?.data?.codigo || null,
                clicks: resolveNotificationClicks(n),
                hexColor,
                canceled: !!n?.canceled,
            };
        }

        if (window.location.pathname.includes('/calendar')) {
            let bulkCancelMode = false;
            const bulkCancelSelection = new Map();

            function isBulkCancelable(event) {
                return !!event?.start
                    && event.start.getTime() > Date.now()
                    && event.extendedProps?.canceled !== true;
            }

            function applyBulkCancelClasses(event, element) {
                if (!element) return;
                element.dataset.bulkCancelEventId = event.id;
                element.classList.toggle('bulk-cancel-eligible', bulkCancelMode && isBulkCancelable(event));
                element.classList.toggle('bulk-cancel-selected', bulkCancelSelection.has(String(event.id)));
            }

            function refreshBulkCancelRenderedEvents() {
                calendarEl.querySelectorAll('.fc-event[data-bulk-cancel-event-id]').forEach((element) => {
                    const event = calendar.getEventById(element.dataset.bulkCancelEventId);
                    if (event) applyBulkCancelClasses(event, element);
                });
            }

            function updateBulkCancelControls() {
                const count = bulkCancelSelection.size;
                $('#bulkCancelCount').text(count);
                bulkCancelConfirmBtn.prop('disabled', count === 0);
                bulkCancelConfirmBtn.toggleClass('d-none', !bulkCancelMode);
                bulkCancelExitBtn.toggleClass('d-none', !bulkCancelMode);
                bulkCancelToggleBtn.toggleClass('d-none', bulkCancelMode);
                bulkCancelToggleBtn.attr('aria-pressed', bulkCancelMode ? 'true' : 'false');
                calendarEl.classList.toggle('bulk-cancel-mode', bulkCancelMode);
                refreshBulkCancelRenderedEvents();
            }

            function setBulkCancelMode(active) {
                bulkCancelMode = !!active;
                if (!bulkCancelMode) bulkCancelSelection.clear();
                updateBulkCancelControls();
            }

            var calendar = new FullCalendar.Calendar(calendarEl, {
                // >>> FIX: deixar o FullCalendar trabalhar em horário local do navegador
                timeZone: 'local',
                defaultTimedEventDuration: '00:00:10',
                forceEventDuration: true,
                locale: 'pt',
                initialView: mobileView ? 'listWeek' : 'dayGridMonth',
                themeSystem: 'bootstrap5',
                headerToolbar: {
                    left: 'title prev,next',
                    center: null,
                    right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
                },
                height: 800,
                contentHeight: 780,
                aspectRatio: 3,
                editable: false,
                droppable: false,
                views: { dayGridMonth: { dayMaxEventRows: 2 } },
                direction: NioApp.State.isRTL ? "rtl" : "ltr",
                nowIndicator: true,

                eventMouseEnter: function (info) {
                    let elm = info.el,
                        title = info.event._def.title,
                        content = info.event._def.extendedProps.description,
                        isEmail = info.event._def.extendedProps.isEmail,
                        eventPrefix = '';
                    // eventPrefix = isEmail ? '[E-mail] ' : '[Push] ';
                    const startDate = info.event.start instanceof Date ? info.event.start : null;
                    const isPastPush = !isEmail && !!startDate && startDate.getTime() < Date.now();
                    const clicks = Number(info.event._def.extendedProps.clicks || 0);
                    const hoverContent = buildCalendarHoverContent(content, clicks, isPastPush);
                    if (hoverContent) {
                        const fcPopover = new bootstrap.Popover(elm, {
                            template: '<div class="popover event-popover"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
                            title: eventPrefix + title,
                            content: hoverContent,
                            html: true,
                            placement: 'left',
                        });
                        fcPopover.show();
                    }
                },

                eventMouseLeave: function () { removePopover(); },
                eventDragStart: function () { removePopover(); },

                events: [],

                eventClick: function (info) {
                    if (bulkCancelMode) {
                        info.jsEvent?.preventDefault();
                        const eventId = String(info.event.id);
                        if (!isBulkCancelable(info.event)) {
                            NioApp.Toast('Selecione somente notificações futuras e não canceladas', 'warning');
                            return;
                        }

                        if (bulkCancelSelection.has(eventId)) {
                            bulkCancelSelection.delete(eventId);
                        } else {
                            bulkCancelSelection.set(eventId, {
                                id: eventId,
                                monthKey: getMonthKeyFromDate(info.event.start),
                                startTime: info.event.start.getTime(),
                            });
                        }
                        updateBulkCancelControls();
                        return;
                    }

                    var title = info.event._def.title;
                    var rawTitle = info.event._def.extendedProps.rawTitle || title;
                    var description = info.event._def.extendedProps.description;
                    var rawDescription = info.event._def.extendedProps.rawDescription || description;

                    // >>> FIX: usa sempre horário LOCAL (não UTC)
                    var start = info.event.start;

                    var startDate = start.getFullYear() + '-' + pad2(start.getMonth() + 1) + '-' + pad2(start.getDate());
                    var startTime = pad2(start.getHours()) + ':' + pad2(start.getMinutes()) + ':' + pad2(start.getSeconds());
                    startTime = (startTime === '00:00:00') ? '' : startTime;

                    var classNameRaw = (info.event._def.ui.classNames && info.event._def.ui.classNames[0]) ? info.event._def.ui.classNames[0] : `fc-${defaultColorClass}`;
                    var className = classNameRaw.startsWith('fc-') ? classNameRaw.slice(3) : classNameRaw;

                    var segment = info.event._def.extendedProps.segment;
                    var segmentName = info.event._def.extendedProps.segmentName;
                    var image = info.event._def.extendedProps.image;
                    var pageUrl = info.event._def.extendedProps.pageUrl;
                    var buttonText = info.event._def.extendedProps.buttonText || '';
                    var headings = info.event._def.extendedProps.headings || null;
                    var contents = info.event._def.extendedProps.contents || null;
                    var defaultLanguage = info.event._def.extendedProps.defaultLanguage || null;
                    var languages = info.event._def.extendedProps.languages || [];
                    var eventId = info.event._def.publicId;
                    var isEmail = info.event._def.extendedProps.isEmail;
                    var trackingCode = info.event._def.extendedProps.trackingCode;
                    var codigo = info.event._def.extendedProps.codigo;
                    var cleanTitle = String(rawTitle || '').replace(/^\[Cancelado\]\s*/, '');
                    const eventPrefix = ''; //isEmail ? '[E-mail] ' : '[Push] ';

                    $('#edit-event-title').val(eventPrefix + cleanTitle);
                    $('#edit-event-start-date').val(startDate).datepicker('update');
                    $('#edit-event-start-time').val(startTime);
                    $('#edit-event-description').val(rawDescription);

                    $('#edit-event-theme').val(className);
                    $('#edit-event-theme').trigger('change.select2');

                    $('#edit-event-image').val(image);
                    $('#edit-event-page-url').val(pageUrl);
                    editEventForm.attr('data-id', eventId);

                    var previewStart = String(start.getDate()).padStart(2, '0') + ' ' + month[start.getMonth()] + ' ' + start.getFullYear() + (startTime ? ' - ' + to12(startTime) : '');
                    $('#preview-event-title').text(eventPrefix + title);

                    $('#preview-event-header').removeClass().addClass('modal-header');
                    $('#preview-event-header').removeAttr('style');
                    $('#preview-event-header').addClass('fc-' + className);

                    $('#preview-event-start').text(previewStart);
                    setPreviewSegmentText(resolveSegmentLabel(segment, segmentName));
                    $('#preview-event-description').text(description);
                    $('#preview-event-image').text(image);

                    if (image == 'Sem imagem') $('#preview-event-image').removeAttr('href');
                    else $('#preview-event-image').attr('href', image);

                    $('#preview-event-url').text(pageUrl);
                    if (!pageUrl || pageUrl.includes('Sem link')) $('#preview-event-url').removeAttr('href');
                    else $('#preview-event-url').attr('href', pageUrl);

                    $('#preview-event-description-check').css('display', description ? 'block' : 'none');
                    $('#preview-event-button-text').text(buttonText);
                    $('#preview-event-button-check').css('display', buttonText ? 'block' : 'none');

                    if (trackingCode || codigo) {
                        $('#preview-event-tracking-code-check').css('display', 'block');
                        $('#preview-event-tracking-code').text(trackingCode || codigo);
                        $('#preview-event-image-check').css('display', 'none');
                        if (trackingCode) $('#preview-event-page-url').css('display', 'none');
                    } else {
                        $('#preview-event-tracking-code-check').css('display', 'none');
                        $('#preview-event-image-check').css('display', 'block');
                        $('#preview-event-page-url').css('display', 'block');
                    }

                    removePopover();
                    let fcMorePopover = document.querySelectorAll('.fc-more-popover');
                    fcMorePopover && fcMorePopover.forEach(elm => elm.remove());

                    previewEventPopup.data('resendPayload', {
                        title: cleanTitle,
                        description: rawDescription,
                        image,
                        pageUrl,
                        buttonText,
                        theme: className,
                        isEmail: !!isEmail,
                        headings,
                        contents,
                        defaultLanguage,
                        languages,
                    });
                    if (resendEventBtn.length) {
                        resendEventBtn.toggle(!isEmail);
                    }
                    previewEventPopup.modal('show');
                },

                eventDidMount: function (info) {
                    applyBulkCancelClasses(info.event, info.el);

                    const hexColor =
                        info.event.extendedProps.hexColor ||
                        info.event.backgroundColor ||
                        info.event.borderColor ||
                        null;

                    if (!hexColor) return;

                    if (String(info.view.type || '').startsWith('list')) {
                        const dot = info.el.querySelector('.fc-list-event-dot');
                        if (dot) {
                            dot.style.setProperty('border-color', hexColor, 'important');
                            dot.style.setProperty('background-color', hexColor, 'important');
                        }
                        return;
                    }

                    if (info.view.type !== 'dayGridMonth') return;

                    const inDayGridDay = !!info.el.closest('.fc-daygrid-day-events');
                    const inMorePopover = !!info.el.closest('.fc-popover-body');
                    if (!inDayGridDay && !inMorePopover) return;

                    const harness = info.el.closest('.fc-daygrid-event-harness');
                    if (harness) harness.style.width = '100%';

                    info.el.style.setProperty('background-color', hexColor, 'important');
                    info.el.style.setProperty('border-color', hexColor, 'important');
                    info.el.style.setProperty('color', idealTextColor(hexColor), 'important');
                    info.el.style.borderRadius = '6px';

                    const dot2 = info.el.querySelector('.fc-daygrid-event-dot');
                    if (dot2) {
                        dot2.style.setProperty('border-color', 'transparent', 'important');
                        dot2.style.setProperty('background-color', 'transparent', 'important');
                    }
                },

                datesSet: function () {
                    const monthKey = getMonthKeyFromDate(calendar.getDate());
                    subscribeMonth(monthKey);
                }
            });

            setupAutomaticFilterUI();

            bulkCancelToggleBtn.on('click', function () {
                setBulkCancelMode(!bulkCancelMode);
                if (bulkCancelMode) {
                    NioApp.Toast('Selecione no calendário as notificações futuras que deseja cancelar', 'info');
                }
            });

            bulkCancelExitBtn.on('click', function () {
                setBulkCancelMode(false);
            });

            bulkCancelConfirmBtn.on('click', function () {
                const count = bulkCancelSelection.size;
                if (!count) return;
                $('#bulkCancelModalCount').text(`${count} ${count === 1 ? 'notificação' : 'notificações'}`);
                $('#bulkCancelPopup').modal('show');
            });

            bulkCancelExecuteBtn.on('click', async function () {
                const selectedNotifications = Array.from(bulkCancelSelection.values());
                if (!selectedNotifications.length) return;

                bulkCancelExecuteBtn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>Cancelando...');
                bulkCancelConfirmBtn.prop('disabled', true);

                const results = await Promise.all(selectedNotifications.map(async (notification) => {
                    try {
                        const monthData = monthDataCache[notification.monthKey];
                        if (notification.startTime <= Date.now() || monthData?.[notification.id]?.canceled) {
                            bulkCancelSelection.delete(notification.id);
                            return false;
                        }

                        const canceled = await deleteEventNotification(notification.id);
                        if (!canceled) return false;

                        if (typeof window.cancelPushNotification === 'function') {
                            const historyCanceled = await window.cancelPushNotification(notification.monthKey, notification.id);
                            if (!historyCanceled) return false;
                        }

                        if (monthData?.[notification.id]) monthData[notification.id].canceled = true;
                        delete monthEventsCache[notification.monthKey];
                        bulkCancelSelection.delete(notification.id);
                        return true;
                    } catch (error) {
                        console.error('Erro ao cancelar notificação em massa:', notification.id, error);
                        return false;
                    }
                }));

                const successCount = results.filter(Boolean).length;
                const errorCount = results.length - successCount;

                if (currentMonthKey) {
                    await renderMonthFromCache(currentMonthKey, { incremental: false });
                }

                $('#bulkCancelPopup').modal('hide');
                bulkCancelExecuteBtn.prop('disabled', false).text('Cancelar notificações');

                if (successCount) {
                    NioApp.Toast(`${successCount} ${successCount === 1 ? 'notificação cancelada' : 'notificações canceladas'} com sucesso`, 'success');
                }
                if (errorCount) {
                    NioApp.Toast(`Não foi possível cancelar ${errorCount} ${errorCount === 1 ? 'notificação' : 'notificações'}`, 'error');
                    updateBulkCancelControls();
                } else {
                    setBulkCancelMode(false);
                }
            });

            // ---------------- cache do mês para re-render rápido ----------------
            let monthRenderToken = 0;
            let monthLoadingToken = 0;
            let monthLoadingToastEl = null;
            const MONTH_RENDER_BATCH_SIZE = mobileView ? 20 : 40;

            function setMonthLoading(isLoading) {
                if (!monthLoadingToastEl || !document.body.contains(monthLoadingToastEl)) {
                    monthLoadingToastEl = document.getElementById('monthLoadingToast');
                }

                if (!monthLoadingToastEl) {
                    monthLoadingToastEl = document.createElement('div');
                    monthLoadingToastEl.id = 'monthLoadingToast';
                    monthLoadingToastEl.setAttribute('role', 'status');
                    monthLoadingToastEl.setAttribute('aria-live', 'polite');
                    monthLoadingToastEl.style.position = 'fixed';
                    monthLoadingToastEl.style.right = '20px';
                    monthLoadingToastEl.style.bottom = '20px';
                    monthLoadingToastEl.style.zIndex = '1300';
                    monthLoadingToastEl.style.display = 'inline-flex';
                    monthLoadingToastEl.style.alignItems = 'center';
                    monthLoadingToastEl.style.gap = '10px';
                    monthLoadingToastEl.style.padding = '20px 24px';
                    monthLoadingToastEl.style.borderRadius = '10px';
                    monthLoadingToastEl.style.border = '1px solid rgba(0,0,0,0.08)';
                    monthLoadingToastEl.style.background = 'rgba(255,255,255,0.96)';
                    monthLoadingToastEl.style.color = '#00286b';
                    monthLoadingToastEl.style.fontSize = '16px';
                    monthLoadingToastEl.style.fontWeight = '600';
                    monthLoadingToastEl.style.boxShadow = '0 8px 20px rgba(0,0,0,0.60)';
                    monthLoadingToastEl.style.pointerEvents = 'none';
                    monthLoadingToastEl.style.opacity = '0';
                    monthLoadingToastEl.style.visibility = 'hidden';
                    monthLoadingToastEl.style.transform = 'translateY(8px)';
                    monthLoadingToastEl.style.transition = 'opacity .16s ease, transform .16s ease, visibility .16s ease';
                    monthLoadingToastEl.innerHTML = '<span class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></span><span>Carregando pushs...</span>';
                    document.body.appendChild(monthLoadingToastEl);
                }

                monthLoadingToastEl.style.opacity = isLoading ? '1' : '0';
                monthLoadingToastEl.style.visibility = isLoading ? 'visible' : 'hidden';
                monthLoadingToastEl.style.transform = isLoading ? 'translateY(0)' : 'translateY(8px)';
            }

            function beginMonthLoading() {
                monthLoadingToken += 1;
                setMonthLoading(true);
                return monthLoadingToken;
            }

            function endMonthLoading(token) {
                if (token !== monthLoadingToken) return;
                setMonthLoading(false);
            }

            function waitNextFrame() {
                return new Promise((resolve) => {
                    if (typeof window.requestAnimationFrame === 'function') {
                        window.requestAnimationFrame(() => resolve());
                    } else {
                        setTimeout(resolve, 0);
                    }
                });
            }

            async function renderMonthFromCache(monthKey = currentMonthKey, options = {}) {
                const incremental = options.incremental !== false;
                const renderToken = ++monthRenderToken;
                const targetMonthKey = monthKey || currentMonthKey;
                const monthData = targetMonthKey ? (monthDataCache[targetMonthKey] || {}) : {};
                const ids = Object.keys(monthData);
                const selectedTypes = getAutomaticTypeFilter();
                const selectedTypesCacheKey = selectedTypes.slice().sort().join('|');
                const monthEventsByFilter = targetMonthKey
                    ? (monthEventsCache[targetMonthKey] || (monthEventsCache[targetMonthKey] = {}))
                    : {};
                const cachedEvents = monthEventsByFilter[selectedTypesCacheKey];

                if (!incremental) {
                    if (Array.isArray(cachedEvents)) {
                        calendar.batchRendering(() => {
                            calendar.removeAllEvents();
                            cachedEvents.forEach(evt => calendar.addEvent(evt));
                        });
                        return renderToken === monthRenderToken;
                    }

                    const events = [];
                    for (let i = 0; i < ids.length; i++) {
                        if (renderToken !== monthRenderToken) return false;
                        const id = ids[i];
                        const evt = mapDbEntryToEvent(id, monthData[id], selectedTypes);
                        if (evt) events.push(evt);
                    }
                    monthEventsByFilter[selectedTypesCacheKey] = events;

                    calendar.batchRendering(() => {
                        calendar.removeAllEvents();
                        events.forEach(evt => calendar.addEvent(evt));
                    });
                    return renderToken === monthRenderToken;
                }

                calendar.removeAllEvents();
                const events = [];

                for (let i = 0; i < ids.length; i += MONTH_RENDER_BATCH_SIZE) {
                    if (renderToken !== monthRenderToken) return false;

                    const end = Math.min(i + MONTH_RENDER_BATCH_SIZE, ids.length);
                    for (let j = i; j < end; j++) {
                        const id = ids[j];
                        const evt = mapDbEntryToEvent(id, monthData[id], selectedTypes);
                        if (evt) {
                            events.push(evt);
                            calendar.addEvent(evt);
                        }
                    }

                    if (end < ids.length) await waitNextFrame();
                }
                monthEventsByFilter[selectedTypesCacheKey] = events;

                return renderToken === monthRenderToken;
            }

            window.addEventListener('calendar:toggleAutomaticPushes', () => {
                renderMonthFromCache(currentMonthKey, { incremental: false }).catch((err) => {
                    console.error('Erro ao re-renderizar pushs no filtro automÃ¡tico:', err);
                });
            });

            function idealTextColor(hex) {
                if (!hex) return '#fff';
                const h = hex.replace('#', '').trim();
                if (h.length !== 6) return '#fff';
                const r = parseInt(h.slice(0, 2), 16);
                const g = parseInt(h.slice(2, 4), 16);
                const b = parseInt(h.slice(4, 6), 16);
                const yiq = (r * 299 + g * 587 + b * 114) / 1000;
                return yiq >= 170 ? '#111' : '#fff';
            }

            async function subscribeMonth(monthKey) {
                if (!monthKey) return;
                currentMonthKey = monthKey;

                const hasCachedData = Object.prototype.hasOwnProperty.call(monthDataCache, monthKey);
                if (hasCachedData) {
                    renderMonthFromCache(monthKey, { incremental: false }).catch((err) => {
                        console.error('Erro ao renderizar mes em cache:', err);
                    });
                    if (window.__autoFilterUI?.updateCounts) {
                        window.__autoFilterUI.updateCounts(monthDataCache[monthKey] || {});
                    }
                }

                if (typeof monthUnsubscribers[monthKey] === 'function') return;
                if (monthSubscribePending[monthKey]) return;
                monthSubscribePending[monthKey] = true;

                const subscribeLoadingToken = hasCachedData ? null : beginMonthLoading();

                const listenFn = await waitForListenPushFn(25, 150);
                if (!listenFn) {
                    monthSubscribePending[monthKey] = false;
                    if (subscribeLoadingToken !== null) endMonthLoading(subscribeLoadingToken);
                    console.error('window.listenPushNotificationsByMonth não foi encontrado.');
                    return;
                }

                // assina o mês e mantém o listener ativo para updates em background
                let initialSnapshotReceived = false;
                try {
                    monthUnsubscribers[monthKey] = listenFn(monthKey, (monthObj) => {
                        Promise.resolve().then(async () => {
                            const monthData = (monthObj && monthObj[monthKey]) ? monthObj[monthKey] : (monthObj || {});
                            monthDataCache[monthKey] = monthData;
                            delete monthEventsCache[monthKey];
                            if (monthKey !== currentMonthKey) return;
                            await renderMonthFromCache(monthKey);

                            if (window.__autoFilterUI?.updateCounts) {
                                window.__autoFilterUI.updateCounts(monthData);
                            }
                        }).catch((err) => {
                            console.error('Erro ao renderizar pushs do mÃªs:', err);
                        }).finally(() => {
                            if (!initialSnapshotReceived) {
                                initialSnapshotReceived = true;
                                if (subscribeLoadingToken !== null) endMonthLoading(subscribeLoadingToken);
                            }
                        });
                    });
                } catch (err) {
                    console.error('Erro ao assinar pushs do mÃªs:', err);
                    if (subscribeLoadingToken !== null) endMonthLoading(subscribeLoadingToken);
                } finally {
                    monthSubscribePending[monthKey] = false;
                }
            }

            // primeira assinatura: mês atual do calendário
            calendar.render();

            const initialMonthKey = getMonthKeyFromDate(calendar.getDate());
            subscribeMonth(initialMonthKey);

            // ---------------- ADD EVENT ----------------
            addEventBtn.on("click", function (e) {
                e.preventDefault();

                const eventLanguagePayload = getEventLanguagePayload();
                const eventStartDate = $('#event-start-date').val();
                const eventStartTime = $('#event-start-time').val();
                const eventTheme = $('#event-theme').val();
                const eventSegment = $('#event-segment').val();
                const selectedSegments = Array.isArray(eventSegment)
                    ? eventSegment.filter(Boolean)
                    : (eventSegment ? [eventSegment] : []);
                const selectedExcludedSegments = getSelectedExcludedSegments();
                const eventImage = $('#event-image').val();
                let eventUrl = $('#event-page-url').val();
                const eventButtonText = ($('#event-button-text').val() || '').trim();
                const eventTitle = eventLanguagePayload.title;
                const eventDescription = eventLanguagePayload.description;
                const languageReviewHtml = buildEventLanguageReviewHtml(eventLanguagePayload);

                const eventStartDateYmd = brDateToYmd(eventStartDate);

                // >>> FIX: gera ISO correto baseado em data/hora LOCAL (sem colocar "Z" manual)
                let startIso = null;
                try {
                    const dLocal = new Date(`${eventStartDateYmd}T${eventStartTime}`);
                    if (!isNaN(dLocal.getTime())) startIso = dLocal.toISOString();
                } catch (err) { }
                if (!startIso) {
                    NioApp.Toast('Data/hora inválida. Verifique o formato.', 'error', { hideDuration: 10000 });
                    return;
                }

                const gmtOffset = new Date().toString().match(/(GMT[-+]\d{4})/)[1];

                addEventForm.removeAttr('novalidate');

                const formImageUrlBkp = document.querySelector('[for="event-image"]')?.dataset?.id;
                const formImageUrl = localStorage.getItem('logo') || formImageUrlBkp || null;

                let isValid = true;
                addEventForm.find('[required]').each(function () {
                    if ($(this).val() === '') {
                        $(this).css({ 'box-shadow': '0 0 5px red' });
                        isValid = false;
                    } else {
                        $(this).css({ 'box-shadow': 'unset' });
                    }
                });

                if (eventLanguagePayload.missingLanguages.length) {
                    const firstMissingLanguage = eventLanguagePayload.missingLanguages[0];
                    const missingLabels = eventLanguagePayload.missingLanguages.map((language) => language.label).join(', ');
                    isValid = false;
                    focusEventLanguageField(firstMissingLanguage.code, firstMissingLanguage.fields[0]);
                    NioApp.Toast(`Preencha título e descrição em: ${missingLabels}`, 'error', { hideDuration: 10000 });
                }

                if (eventImage && !eventImage.startsWith('http')) {
                    isValid = false;
                    NioApp.Toast('O link da imagem deve iniciar com http ou https', 'error', { hideDuration: 10000 });
                }

                if (eventUrl && !eventUrl.startsWith('http')) {
                    isValid = false;
                    NioApp.Toast('O link de direcionamento deve iniciar com http ou https', 'error', { hideDuration: 10000 });
                }

                if (eventUrl && eventUrl.includes('instagram.com')) {
                    eventUrl = eventUrl.replace('www.', '');
                }

                if (eventUrl && (eventUrl.includes('.png') || eventUrl.includes('.jpg') || eventUrl.includes('.webp'))) {
                    NioApp.Toast('Confira se o link para navegação está correto, detectamos uma imagem.', 'error', { hideDuration: 10000 });
                }

                if (!selectedSegments.length) {
                    isValid = false;
                    NioApp.Toast('Selecione pelo menos um publico-alvo', 'error', { hideDuration: 10000 });
                }
                const hasTotalWithOthers = selectedSegments.includes('Total Subscriptions') &&
                    selectedSegments.some((segment) => segment !== 'Total Subscriptions');
                if (hasTotalWithOthers) {
                    isValid = false;
                    NioApp.Toast('Nao e permitido combinar "Todos os inscritos" com outros publicos', 'error', { hideDuration: 10000 });
                }

                const hasExcludedSegmentOverlap = selectedExcludedSegments.some((segment) => selectedSegments.includes(segment));
                if (hasExcludedSegmentOverlap) {
                    isValid = false;
                    NioApp.Toast('Remova dos publicos excluidos os itens que ja estao no publico-alvo', 'error', { hideDuration: 10000 });
                }

                if (selectedSegments.includes(TOTAL_SUBSCRIPTIONS_SEGMENT) && selectedExcludedSegments.length) {
                    isValid = false;
                    NioApp.Toast('Nao e possivel excluir publicos quando "Todos os inscritos" estiver selecionado', 'error', { hideDuration: 10000 });
                }

                const includedUserIdSegments = getUserIdSegments(selectedSegments);
                const includedNativeSegments = getNativeSegments(selectedSegments);
                const excludedUserIdSegments = getUserIdSegments(selectedExcludedSegments);
                const excludedNativeSegments = getNativeSegments(selectedExcludedSegments);
                const hasMixedIncludedTargeting = includedUserIdSegments.length > 0 && includedNativeSegments.length > 0;
                const hasUnsupportedExcludedTargeting = selectedExcludedSegments.length > 0 && (
                    hasMixedIncludedTargeting ||
                    (excludedUserIdSegments.length > 0 && !includedUserIdSegments.length) ||
                    (excludedNativeSegments.length > 0 && !includedNativeSegments.length)
                );

                if (hasUnsupportedExcludedTargeting) {
                    isValid = false;
                    NioApp.Toast('A exclusao so pode ser usada quando publico-alvo e publicos excluidos usam o mesmo tipo de publico', 'error', { hideDuration: 10000 });
                }

                if (
                    !hasUnsupportedExcludedTargeting &&
                    includedUserIdSegments.length > 0 &&
                    !includedNativeSegments.length &&
                    typeof getEffectiveSubscriptionIdsFromSegments === 'function'
                ) {
                    const remainingSubscriptionIds = getEffectiveSubscriptionIdsFromSegments(includedUserIdSegments, excludedUserIdSegments);
                    if (!remainingSubscriptionIds.length) {
                        isValid = false;
                        NioApp.Toast('Nenhum usuario restou no publico final apos aplicar as exclusoes', 'error', { hideDuration: 10000 });
                    }
                }

                if (!isValid) return;

                Swal.fire({
                    title: 'Revise os dados',
                    html:
                        `<div style="text-align:left"><br>
              ${languageReviewHtml}
              Data: <b>${escapeHtml(eventStartDate)} - ${escapeHtml(eventStartTime)}</b><br><br>
              Imagem de corpo: <b>${eventImage ? `<a href="${escapeHtml(eventImage)}" target="_blank">Link</a>` : 'Sem imagem'}</b><br><br>
              Direcionamento do clique: <b>${eventUrl ? `<a href="${escapeHtml(eventUrl)}" target="_blank">Link</a>` : 'Sem link'}</b><br><br>
              Botão do push: <b>${escapeHtml(eventButtonText || 'Sem botão')}</b>
              ${eventLanguagePayload.hasPersonalization ? `<div style="margin-top:16px; padding:12px 14px; border-radius:14px; background:rgb(101 15 172 / 8%); color:#4a0f73;"><strong>Personalização ativa:</strong> esta revisão mostra a alternativa configurada para o nome.</div>` : ''}
            </div>`,
                    showCancelButton: true,
                    confirmButtonColor: "#437FFF",
                    confirmButtonText: 'Programar',
                    cancelButtonText: 'Editar'
                }).then((result) => {
                    if (!result.isConfirmed) return;

                    const loadingPopup = document.getElementById('loadingPopup');
                    if (loadingPopup) loadingPopup.style.display = 'flex';

                    const eventJson = {
                        id: 'added-event-id-' + Math.floor(Math.random() * 9999999),
                        title: eventTitle,
                        headings: eventLanguagePayload.headings,
                        start: startIso, // ISO (UTC) correto gerado a partir do horário local
                        schedule: `${eventStartDateYmd} ${eventStartTime} ${gmtOffset}`,
                        className: "fc-" + eventTheme,
                        description: eventDescription,
                        contents: eventLanguagePayload.contents,
                        defaultLanguage: eventLanguagePayload.defaultLanguage,
                        languages: eventLanguagePayload.languages,
                        image: eventImage,
                        largeIcon: formImageUrl,
                        pageUrl: eventUrl,
                        buttonText: eventButtonText,
                        eventSegment: selectedSegments,
                        segmentName: buildSegmentNameMap(selectedSegments),
                        excludedSegments: selectedExcludedSegments
                    };

                    const color = colors[eventTheme] || colors['event-info'];

                    postEventNotification({ ...eventJson, color }).then((id) => {
                        if (loadingPopup) loadingPopup.style.display = 'none';
                        if (id) {
                            addEventPopup.modal('hide');
                            showToast('Notificação agendada com sucesso', 'success', { hideDuration: 10000 });
                        }
                    }).catch(() => {
                        if (loadingPopup) loadingPopup.style.display = 'none';
                    });
                });
            });

            // ---------------- ADD EMAIL ----------------
            addEmailBtn.on("click", function (e) {
                e.preventDefault();

                const emailPublic = $('#event-email-public').val();
                const emailTitle = $('#event-email-title').val();
                const emailDescription = $('#event-email-description').val();
                const emailStartDate = $('#event-email-start-date').val();
                const emailStartTime = $('#event-email-start-time').val();
                const emailImage = $('#event-email-image').val();
                const emailRedirect = $('#event-email-redirect').val();

                const emailStartDateYmd = brDateToYmd(emailStartDate);

                // >>> FIX: ISO correto baseado em data/hora LOCAL
                let startIso = null;
                try {
                    const dLocal = new Date(`${emailStartDateYmd}T${emailStartTime}`);
                    if (!isNaN(dLocal.getTime())) startIso = dLocal.toISOString();
                } catch (err) { }
                if (!startIso) {
                    NioApp.Toast('Data/hora inválida. Verifique o formato.', 'error', { hideDuration: 10000 });
                    return;
                }

                const gmtOffset = new Date().toString().match(/(GMT[-+]\d{4})/)[1];

                addEmailForm.removeAttr('novalidate');

                let isValid = true;
                addEmailForm.find('[required]').each(function () {
                    if ($(this).val() === '') {
                        $(this).css({ 'box-shadow': '0 0 5px red' });
                        isValid = false;
                    } else {
                        $(this).css({ 'box-shadow': 'unset' });
                    }
                });

                if (!isValid) return;

                if (emailImage) {
                    if (isValidUrl(emailImage)) {
                        const image = document.getElementById('imageTemplate');
                        if (image) image.src = emailImage;

                        if (emailRedirect && image) {
                            const elementLink = document.createElement('a');
                            elementLink.href = emailRedirect;
                            elementLink.target = '_blank';
                            elementLink.appendChild(image.cloneNode(true));
                            image.parentNode.replaceChild(elementLink, image);
                        }
                    } else {
                        $('#event-email-image').css({ 'box-shadow': '0 0 5px red' });
                        return;
                    }
                }

                let newCss = `@media (min-width: 600px) { .body { width: 70%; margin: 0 auto; } }`;
                let previewTemplate = document.getElementById('preview-template');
                let styleTag = previewTemplate.querySelector('style');
                if (!styleTag) {
                    styleTag = document.createElement('style');
                    previewTemplate.appendChild(styleTag);
                }
                if (styleTag.styleSheet) styleTag.styleSheet.cssText += newCss;
                else styleTag.appendChild(document.createTextNode(newCss));

                const emailHtml = $('#preview-template').html();

                const eventJson = {
                    title: emailTitle,
                    description: emailDescription,
                    start: startIso,
                    schedule: `${emailStartDateYmd} ${emailStartTime} ${gmtOffset}`,
                    public: emailPublic,
                    html: emailHtml,
                };

                postEventNotification(eventJson).then(id => {
                    if (id) {
                        addEmailPopup.modal('hide');
                        NioApp.Toast('E-mail agendado com sucesso', 'success');
                    }
                });
            });

            // ---------------- DELETE EVENT ----------------
            deleteEventBtn.on("click", async function (e) {
                e.preventDefault();
                const idEvent = editEventForm[0].dataset.id;
                const evt = calendar.getEventById(idEvent);
                const monthKey = evt?.start ? getMonthKeyFromDate(evt.start) : getMonthKeyFromDate(calendar.getDate());
                try {
                    const response = await deleteEventNotification(idEvent);
                    if (response) {
                        if (typeof window.cancelPushNotification === 'function') {
                            await window.cancelPushNotification(monthKey, idEvent);
                        }
                        NioApp.Toast('Notificação cancelada com sucesso', 'success');
                    }
                } catch (error) {
                    console.error("Erro ao cancelar a notificação:", error);
                    NioApp.Toast('Erro ao cancelar a notificação', 'error');
                }
            });

            // ---------------- PRESETS ----------------
            var presets = {
                'event-moda-m': { title: 'Estilo em Oferta! 🕶️', description: 'Moda masculina selecionada com até 50% de desconto. Vista-se bem, gaste pouco!', url: 'https://cdn.shopify.com/s/files/1/0837/9931/0622/files/promo-moda-m.jpg?v=1699221392' },
                'event-moda-f': { title: 'Chique é Pagar Menos! 👗', description: 'Descubra as ofertas exclusivas em moda feminina e renove seu estilo!', url: 'https://cdn.shopify.com/s/files/1/0837/9931/0622/files/promo-moda-f.jpg?v=1699221392' },
                'event-blackf-promo': { title: 'Descontos Explosivos! 💥', description: 'Os maiores descontos do ano com até 60% OFF nesta Black Friday. Aproveite já!', url: 'https://cdn.shopify.com/s/files/1/0837/9931/0622/files/blackfriday.jpg?v=1699221392' },
                'event-blackf-cupom20': { title: 'Esquenta Black Friday! 🖤', description: 'Antecipe suas compras com o cupom DIGITEAQUI de até 20% OFF. Pegue agora!', url: 'https://cdn.shopify.com/s/files/1/0837/9931/0622/files/cupom-20off.jpg?v=1699221392' },
                'event-blackf-cupom50': { title: 'Black Friday Surpresa! 🎉', description: 'Não espere mais! Cupom DIGITEAQUI com 50% OFF em produtos selecionados.', url: 'https://cdn.shopify.com/s/files/1/0837/9931/0622/files/cupom-blackfriday.jpg?v=1699221392' },
                'event-download-1': { title: 'Nova Versão Disponível! 🌟', description: 'Baixe a nova versão do nosso app e descubra novidades que facilitam sua vida!', url: 'https://cdn.shopify.com/s/files/1/0837/9931/0622/files/download-att1.jpg?v=1718472013' },
                'event-download-2': { title: 'Atualize e Experimente! 🌟', description: 'A nova versão do nosso app traz novas ofertas e funcionalidades incríveis!', url: 'https://cdn.shopify.com/s/files/1/0837/9931/0622/files/download-att2.jpg?v=1718471964' },
                'event-rating-1': { title: 'Sua Opinião é Importantíssima 🌟', description: 'Deixe seu feedback e contribua para um app ainda melhor.', url: 'https://cdn.shopify.com/s/files/1/0837/9931/0622/files/avalie-1.jpg?v=1697324467' },
                'event-rating-2': { title: 'Aqui, você é a Estrela! 🌟', description: 'Dê-nos 5 estrelas e conte o que você ama no app!', url: 'https://cdn.shopify.com/s/files/1/0837/9931/0622/files/avalie-2.jpg?v=1699221391' },
                'event-rating-3': { title: 'Ajude-nos a Melhorar! 🌟', description: 'Leva só um minuto para avaliar o app. Sua opinião conta muito para nós!', url: 'https://cdn.shopify.com/s/files/1/0837/9931/0622/files/avalie-3.jpg?v=1699221391' }
            };

            $('#event-template').on('select2:select', function (e) {
                const selectedOption = e.params.data.id;
                if (presets[selectedOption]) {
                    document.getElementById('event-title').value = presets[selectedOption].title;
                    document.getElementById('event-description').value = presets[selectedOption].description;
                    document.getElementById('event-image').value = presets[selectedOption].url;

                    updatePreview('title', presets[selectedOption].title);
                    updatePreview('description', presets[selectedOption].description);
                    updatePreview('image', presets[selectedOption].url);
                    syncPushPersonalizationStatus('event-title');
                    syncPushPersonalizationStatus('event-description');
                } else {
                    document.getElementById('event-title').value = '';
                    document.getElementById('event-description').value = '';
                    document.getElementById('event-image').value = '';

                    updatePreview('title', 'Título da Notificação');
                    updatePreview('description', 'Descrição...');
                    updatePreview('image', '');
                    syncPushPersonalizationStatus('event-title');
                    syncPushPersonalizationStatus('event-description');
                }
            });

            // ---------------- EMAIL TEMPLATE ----------------
            var emailTemplate = {
                'depoimento': {
                    title: 'Opinião dos clientes',
                    description: 'Produtos selecionados no app',
                    image: 'https://cdn.shopify.com/s/files/1/0837/9931/0622/files/Email_marketing_1_653e4858-f74a-4de0-abe1-b4650392e25d.jpg?v=1702937410',
                    html: '<!doctype html>\n<html>\n <head>\n </head>\n <style>\n \t.body {\n \tbackground-color:#F5F5F3 !important;\n text-align: center;\n margin: 0;\n padding: 0;\n }\n </style>\n <body>\n <div class="body">\n <img id="imageTemplate" style="width:100%">\n <div class="our-class" style="text-align: center;margin-top: 10px;">\n <a href="https://play.google.com/store/apps/details?id=com.techneves.store" target="_blank" style="height: 300px">\n <img src="https://cdn.shopify.com/s/files/1/0837/9931/0622/files/btngoogle.jpg?v=1702938358" style="width: 45%"></a>\n <a href="https://apps.apple.com/us/app/tech-neves/id6471194135" target="_blank" style="margin-left: 10px">\n <img src="https://cdn.shopify.com/s/files/1/0837/9931/0622/files/btnapple.jpg?v=1702938357" style="width: 45%">\n </a>\n</div>\n \n <div style="margin-top:100px;text-align: center;">\n <a href="[unsubscribe_url]" data-disable-tracking="true" style="display: inline; text-decoration: none;">Cancelar</a>\n <p style="display: inline;"> recebimento de e-mails</p>\n</div></div>\n </body>\n</html>',
                },
                'natal': {
                    title: 'Oportunidade de Natal',
                    description: '50% OFF',
                    image: 'https://cdn.shopify.com/s/files/1/0837/9931/0622/files/Email-natal.jpg?v=1703357400',
                    html: '<!doctype html>\n<html>\n <head>\n </head>\n <style>\n \t.body {\n \tbackground-color:#F5F5F3 !important;\n text-align: center;\n margin: 0;\n padding: 0;\n }\n </style>\n <body>\n <div class="body">\n <img id="imageTemplate" style="width:100%">\n <div class="our-class" style="text-align: center;margin-top: 10px;">\n <a href="https://play.google.com/store/apps/details?id=com.techneves.store" target="_blank" style="height: 300px">\n <img src="https://cdn.shopify.com/s/files/1/0837/9931/0622/files/btngoogle.jpg?v=1702938358" style="width: 45%"></a>\n <a href="https://apps.apple.com/us/app/tech-neves/id6471194135" target="_blank" style="margin-left: 10px">\n <img src="https://cdn.shopify.com/s/files/1/0837/9931/0622/files/btnapple.jpg?v=1702938357" style="width: 45%">\n </a>\n</div>\n \n <div style="margin-top:100px;text-align: center;">\n <a href="[unsubscribe_url]" data-disable-tracking="true" style="display: inline; text-decoration: none;">Cancelar</a>\n <p style="display: inline;"> recebimento de e-mails</p>\n</div></div>\n </body>\n</html>',
                }
            };

            $('#event-email-template').on('select2:select', function (e) {
                const selectedOption = e.params.data.id;
                if (emailTemplate[selectedOption]) {
                    document.getElementById('event-email-title').value = emailTemplate[selectedOption].title;
                    document.getElementById('event-email-description').value = emailTemplate[selectedOption].description;
                    document.getElementById('event-email-image').value = emailTemplate[selectedOption].image;
                    document.getElementById('preview-template').innerHTML = emailTemplate[selectedOption].html;

                    updateEmailPreview('title', emailTemplate[selectedOption].title);
                    updateEmailPreview('description', emailTemplate[selectedOption].description);
                    updateEmailPreview('image', emailTemplate[selectedOption].image);
                } else {
                    document.getElementById('event-email-title').value = '';
                    document.getElementById('event-email-description').value = '';
                    document.getElementById('event-email-image').value = '';
                    document.getElementById('preview-template').innerHTML = '';

                    updateEmailPreview('title', 'Título do e-mail');
                    updateEmailPreview('description', '');
                    updateEmailPreview('image', '');
                }
            });

            const TOTAL_SUBSCRIPTIONS_SEGMENT = 'Total Subscriptions';
            let segmentSelectionSyncing = false;
            let excludedSegmentSyncing = false;

            function getSelectValues(selector) {
                const selected = $(selector).val();
                if (Array.isArray(selected)) return selected.filter(Boolean);
                return selected ? [selected] : [];
            }

            function getSelectedSegments() {
                return getSelectValues('#event-segment');
            }

            function getSelectedExcludedSegments() {
                return getSelectValues('#event-excluded-segments');
            }

            function getUserIdSegments(segments) {
                return segments.filter((segment) => segment.startsWith('userIds'));
            }

            function getNativeSegments(segments) {
                return segments.filter((segment) => !segment.startsWith('userIds'));
            }

            function getSegmentTargetType(segment) {
                return segment.startsWith('userIds') ? 'subscriptionIds' : 'oneSignal';
            }

            function syncSelectAllEventSegmentsButton() {
                const selectAllButton = document.getElementById('selectAllEventSegmentsBtn');
                if (!selectAllButton) return;

                selectAllButton.hidden = getSelectedExcludedSegments().length === 0;
            }

            function selectAllCompatibleEventSegments() {
                const segmentSelect = document.getElementById('event-segment');
                const selectedExcludedSegments = getSelectedExcludedSegments();
                if (!segmentSelect || !selectedExcludedSegments.length) {
                    syncSelectAllEventSegmentsButton();
                    return;
                }

                const excludedTargetTypes = new Set(selectedExcludedSegments.map(getSegmentTargetType));
                if (excludedTargetTypes.size !== 1) {
                    NioApp.Toast('Selecione públicos excluídos do mesmo tipo para selecionar todos os demais', 'error', { hideDuration: 10000 });
                    return;
                }

                const excludedSegmentSet = new Set(selectedExcludedSegments);
                const targetType = excludedTargetTypes.values().next().value;
                const compatibleSegments = Array.from(segmentSelect.options)
                    .map((option) => option.value)
                    .filter((segment) =>
                        segment &&
                        segment !== TOTAL_SUBSCRIPTIONS_SEGMENT &&
                        !excludedSegmentSet.has(segment) &&
                        getSegmentTargetType(segment) === targetType
                    );

                if (!compatibleSegments.length) {
                    NioApp.Toast('Não há outros públicos disponíveis para selecionar', 'warning', { hideDuration: 10000 });
                    return;
                }

                $(segmentSelect).val(compatibleSegments).trigger('change');
            }

            function getSegmentIdsFromStorage(segmentKey) {
                if (!segmentKey || !segmentKey.startsWith('userIds')) return [];

                try {
                    const rawIds = localStorage.getItem(segmentKey);
                    if (!rawIds) return [];

                    const parsedIds = JSON.parse(rawIds);
                    if (!Array.isArray(parsedIds)) return [];

                    return Array.from(new Set(parsedIds
                        .map((subscriptionId) => typeof subscriptionId === 'string' ? subscriptionId.trim() : '')
                        .filter(Boolean)));
                } catch (error) {
                    console.warn('Erro ao ler IDs do segmento', segmentKey, error);
                    return [];
                }
            }

            function ensureSegmentOptionMeta(option) {
                if (!option) return;

                const currentText = String(option.textContent || '').replace(/\s+/g, ' ').trim();
                if (!option.dataset.originalLabel) {
                    const textMatch = currentText.match(/^(.*)\s-\s\((\d+)\)$/);
                    option.dataset.originalLabel = textMatch ? textMatch[1] : currentText;
                }

                if (option.value && option.value.startsWith('userIds')) {
                    const originalCount = getSegmentIdsFromStorage(option.value).length;
                    option.dataset.originalCount = String(originalCount);
                    option.dataset.originalText = `${option.dataset.originalLabel} - (${originalCount})`;
                } else {
                    option.dataset.originalCount = '';
                    option.dataset.originalText = currentText;
                }
            }

            function getOriginalSegmentOptionText(option) {
                ensureSegmentOptionMeta(option);
                return option?.dataset?.originalText || String(option?.textContent || '').trim();
            }

            function getCurrentSegmentOptionText(item) {
                if (item?.element?.textContent) return String(item.element.textContent).trim();
                return String(item?.text || '').trim();
            }

            function getExcludedUserIdSet() {
                const excludedIds = new Set();
                getUserIdSegments(getSelectedExcludedSegments()).forEach((segmentKey) => {
                    getSegmentIdsFromStorage(segmentKey).forEach((subscriptionId) => excludedIds.add(subscriptionId));
                });
                return excludedIds;
            }

            function flashChangedSegmentSelections(segmentChangeMap) {
                const selectedSegments = getSelectedSegments();
                const segmentSelectContainer = $('#event-segment').next('.select2-container');
                if (!segmentSelectContainer.length) return;

                window.requestAnimationFrame(() => {
                    window.setTimeout(() => {
                        const choiceNodes = segmentSelectContainer.find('.select2-selection__choice').get();

                        choiceNodes.forEach((choiceNode, index) => {
                            choiceNode.classList.remove('segment-count-flash-up', 'segment-count-flash-down');

                            const segmentChange = segmentChangeMap.get(selectedSegments[index]);
                            if (!segmentChange) return;

                            const changeClass = segmentChange === 'up'
                                ? 'segment-count-flash-up'
                                : 'segment-count-flash-down';

                            choiceNode.classList.add(changeClass);
                            window.setTimeout(() => {
                                choiceNode.classList.remove(changeClass);
                            }, 2600);
                        });
                    }, 0);
                });
            }

            function refreshSegmentCountLabels(options = {}) {
                const { flash = false } = options;
                const segmentSelect = document.getElementById('event-segment');
                if (!segmentSelect) return;

                const excludedIds = getExcludedUserIdSet();
                const segmentChangeMap = new Map();
                let changed = false;

                Array.from(segmentSelect.options).forEach((option) => {
                    ensureSegmentOptionMeta(option);

                    if (!option.value || !option.value.startsWith('userIds')) {
                        const originalText = getOriginalSegmentOptionText(option);
                        if (option.textContent !== originalText) {
                            option.textContent = originalText;
                            changed = true;
                        }
                        option.title = originalText;
                        option.dataset.currentAdjustedCount = '';
                        return;
                    }

                    const originalIds = getSegmentIdsFromStorage(option.value);
                    const previousAdjustedCount = option.dataset.currentAdjustedCount !== ''
                        && option.dataset.currentAdjustedCount !== undefined
                        ? Number(option.dataset.currentAdjustedCount)
                        : originalIds.length;
                    const adjustedCount = originalIds.filter((subscriptionId) => !excludedIds.has(subscriptionId)).length;
                    const nextText = `${option.dataset.originalLabel} - (${adjustedCount})`;

                    if (option.textContent !== nextText) {
                        option.textContent = nextText;
                        changed = true;
                    }

                    option.title = nextText;
                    option.dataset.currentAdjustedCount = String(adjustedCount);

                    if (flash && option.selected && adjustedCount !== previousAdjustedCount) {
                        segmentChangeMap.set(option.value, adjustedCount > previousAdjustedCount ? 'up' : 'down');
                    }
                });

                if (changed) {
                    $('#event-segment').trigger('change.select2');
                }

                if (flash) {
                    flashChangedSegmentSelections(segmentChangeMap);
                }
            }

            function syncExcludedSegmentOptions() {
                if (excludedSegmentSyncing) return;

                const segmentSelect = document.getElementById('event-segment');
                const excludedSegmentSelect = document.getElementById('event-excluded-segments');
                if (!segmentSelect || !excludedSegmentSelect) return;

                excludedSegmentSyncing = true;

                try {
                    const selectedSegments = getSelectedSegments();
                    const selectedExcludedSegments = getSelectedExcludedSegments();
                    const disableExcludedSelect = selectedSegments.includes(TOTAL_SUBSCRIPTIONS_SEGMENT);
                    const availableOptions = Array.from(segmentSelect.options)
                        .filter((option) =>
                            option.value &&
                            option.value !== TOTAL_SUBSCRIPTIONS_SEGMENT &&
                            !selectedSegments.includes(option.value)
                        )
                        .map((option) => ({
                            value: option.value,
                            text: getOriginalSegmentOptionText(option),
                            title: getOriginalSegmentOptionText(option)
                        }));

                    excludedSegmentSelect.innerHTML = '';

                    availableOptions.forEach((optionData) => {
                        const newOption = document.createElement('option');
                        newOption.value = optionData.value;
                        newOption.textContent = optionData.text;
                        newOption.title = optionData.title;
                        excludedSegmentSelect.appendChild(newOption);
                    });

                    const nextExcludedSelection = disableExcludedSelect
                        ? []
                        : selectedExcludedSegments.filter((segment) =>
                            availableOptions.some((option) => option.value === segment)
                        );

                    $(excludedSegmentSelect).val(nextExcludedSelection);
                    $(excludedSegmentSelect).prop('disabled', disableExcludedSelect || !availableOptions.length);
                    $(excludedSegmentSelect).trigger('change.select2');
                } finally {
                    excludedSegmentSyncing = false;
                }

                syncSelectAllEventSegmentsButton();
            }

            function syncSegmentOptions() {
                const selected = getSelectedSegments();
                const hasTotal = selected.includes(TOTAL_SUBSCRIPTIONS_SEGMENT);
                const hasOthers = selected.some((segment) => segment !== TOTAL_SUBSCRIPTIONS_SEGMENT);
                let changed = false;

                $('#event-segment option').each(function () {
                    const shouldDisable = this.value === TOTAL_SUBSCRIPTIONS_SEGMENT ? hasOthers : hasTotal;
                    if (this.disabled !== shouldDisable) {
                        this.disabled = shouldDisable;
                        changed = true;
                    }
                });

                if (changed) $('#event-segment').trigger('change.select2');
                syncExcludedSegmentOptions();
                refreshSegmentCountLabels();
            }

            function enforceExclusiveSegmentSelection(preferredSegment = null) {
                if (segmentSelectionSyncing) return;
                segmentSelectionSyncing = true;

                try {
                    const selected = getSelectedSegments();
                    const hasTotal = selected.includes(TOTAL_SUBSCRIPTIONS_SEGMENT);
                    const hasOthers = selected.some((segment) => segment !== TOTAL_SUBSCRIPTIONS_SEGMENT);

                    if (hasTotal && hasOthers) {
                        const nextSelection = preferredSegment === TOTAL_SUBSCRIPTIONS_SEGMENT
                            ? [TOTAL_SUBSCRIPTIONS_SEGMENT]
                            : selected.filter((segment) => segment !== TOTAL_SUBSCRIPTIONS_SEGMENT);
                        $('#event-segment').val(nextSelection);
                    }

                    syncSegmentOptions();
                } finally {
                    segmentSelectionSyncing = false;
                }
            }

            function initSegmentSelectionRules() {
                const segmentSelect = $('#event-segment');
                const excludedSegmentSelect = $('#event-excluded-segments');
                const selectAllSegmentsButton = $('#selectAllEventSegmentsBtn');
                if (!segmentSelect.length) return;

                segmentSelect.off('.segmentRule');
                segmentSelect.on('select2:select.segmentRule', function (e) {
                    const selectedId = e?.params?.data?.id || null;
                    enforceExclusiveSegmentSelection(selectedId);
                });
                segmentSelect.on('select2:unselect.segmentRule change.segmentRule', function () {
                    enforceExclusiveSegmentSelection();
                });

                if (excludedSegmentSelect.length) {
                    excludedSegmentSelect.off('.excludedSegmentRule');
                    excludedSegmentSelect.on('change.excludedSegmentRule', function () {
                        syncExcludedSegmentOptions();
                        refreshSegmentCountLabels({ flash: true });
                    });
                }

                if (selectAllSegmentsButton.length) {
                    selectAllSegmentsButton.off('.selectAllSegments');
                    selectAllSegmentsButton.on('click.selectAllSegments', selectAllCompatibleEventSegments);
                }

                const segmentSelectEl = segmentSelect.get(0);
                if (segmentSelectEl && typeof MutationObserver !== 'undefined') {
                    const segmentObserver = new MutationObserver(() => {
                        syncExcludedSegmentOptions();
                        refreshSegmentCountLabels();
                    });
                    segmentObserver.observe(segmentSelectEl, { childList: true, subtree: true });
                }

                enforceExclusiveSegmentSelection();
                syncExcludedSegmentOptions();
                refreshSegmentCountLabels();
                syncSelectAllEventSegmentsButton();
            }

            function normalizeModalValue(value, emptyCheck) {
                if (!value) return '';
                const text = String(value).trim();
                if (!text) return '';
                if (emptyCheck && emptyCheck(text)) return '';
                return text;
            }

            function openResendEventModal(payload) {
                if (!payload || payload.isEmail) return;

                const title = toEditorPushText(normalizeModalValue(payload.title));
                const description = toEditorPushText(normalizeModalValue(payload.description));
                const image = normalizeModalValue(payload.image, (text) => text.toLowerCase().includes('sem imagem'));
                const pageUrl = normalizeModalValue(payload.pageUrl, (text) => text.toLowerCase().includes('sem link'));
                const buttonText = normalizeModalValue(payload.buttonText);
                const themeOptions = $('#event-theme option').map((_, opt) => opt.value).get();
                const eventTheme = themeOptions.includes(payload.theme) ? payload.theme : defaultColorClass;

                previewEventPopup.modal('hide');
                skipAutoDateFillOnce = true;
                updateDate = false;

                addEventPopup.one('shown.bs.modal', function () {
                    setEventLanguagePayload({
                        title,
                        description,
                        headings: payload.headings,
                        contents: payload.contents,
                        defaultLanguage: payload.defaultLanguage,
                        languages: payload.languages,
                    });
                    $('#event-image').val(image);
                    $('#event-page-url').val(pageUrl);
                    $('#event-button-text').val(buttonText);
                    $('#event-theme').val(eventTheme).trigger('change.select2');
                    $('#event-segment').val([]).trigger('change');
                    $('#event-excluded-segments').val([]).trigger('change');

                    updatePreview('title', title || 'T\u00edtulo da Notifica\u00e7\u00e3o');
                    updatePreview('description', description || 'Descri\u00e7\u00e3o...');
                    updatePreview('image', image);
                    updatePreview('button', buttonText);
                });

                addEventPopup.modal('show');
            }

            // ---------------- UI / MODALS ----------------
            NioApp.Select2('.select-calendar-theme', {
                templateResult: customCalSelect,
                templateSelection: customCalSelection
            });
            initSegmentSelectionRules();

            if (resendEventBtn.length) {
                resendEventBtn.on('click', function (e) {
                    e.preventDefault();
                    const payload = previewEventPopup.data('resendPayload');
                    if (!payload) return;
                    openResendEventModal(payload);
                });
            }

            let updateDate = true;
            let skipAutoDateFillOnce = false;

            addEventPopup.on('hidden.bs.modal', function (e) {
                updateDate = true;
                setTimeout(function () {
                    $('#addEventForm input,#addEventForm textarea').val('');
                    resetEventLanguageControls();
                    $('#event-theme').val(defaultColorClass);
                    $('#event-theme').trigger('change.select2');
                    updatePreview('title', 'Título da Notificação');
                    updatePreview('description', 'Descrição...');
                    updatePreview('image', '');
                    updatePreview('button', '');
                    syncPushPersonalizationStatus('event-title');
                    syncPushPersonalizationStatus('event-description');
                    closePushPersonalizationMenus();
                    document.querySelectorAll('[data-personalization-fallback]').forEach((field) => {
                        field.value = PUSH_PERSONALIZATION_DEFAULT_FALLBACK;
                        updatePushPersonalizationPreview(field.dataset.personalizationFallback);
                    });
                }, 1000);
            });

            previewEventPopup.on('hidden.bs.modal', function (e) {
                const segmentTooltip = window.bootstrap?.Tooltip?.getInstance(document.getElementById('preview-event-segment'));
                if (segmentTooltip) segmentTooltip.dispose();
                $('#preview-event-header').removeClass().addClass('modal-header');
                $('#preview-event-header').removeAttr('style');
                $('#preview-event-button-text').text('');
                $('#preview-event-button-check').css('display', 'none');
                previewEventPopup.removeData('resendPayload');
                if (resendEventBtn.length) resendEventBtn.show();
            });

            addEventPopup.on('show.bs.modal', function (e) {
                if (updateDate && !skipAutoDateFillOnce) {
                    fillCurrentDateTime();
                }
                updateDate = false;
                skipAutoDateFillOnce = false;
            });

            addEmailPopup.on('show.bs.modal', function (e) {
                fillCurrentDateTime();
            });

        } // end if /calendar
    };

    NioApp.coms.docReady.push(NioApp.Calendar);

})(NioApp, jQuery);

/* ------------------ AUX FUNCS (mantidas) ------------------ */
function removePopover() {
    let fcPopover = document.querySelectorAll('.event-popover');
    fcPopover.forEach(elm => elm.remove());
}

function to12(time) {
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    if (time.length > 1) {
        time = time.slice(1);
        time.pop();
        time[5] = +time[0] < 12 ? ' AM' : ' PM';
        time[0] = +time[0] % 12 || 12;
    }
    time = time.join('');
    return time;
}

function customCalSelect(cat) {
    var displayText = cat?.element?.textContent
        ? String(cat.element.textContent).trim()
        : String(cat?.text || '').trim();
    if (!cat.id) return displayText;
    displayText = escapeHtml(displayText);
    var $cat = $('<span class="fc-' + cat.element.value + '"> <span class="dot"></span>' + displayText + '</span>');
    return $cat;
}

function customCalSelection(cat) {
    return cat?.element?.textContent
        ? String(cat.element.textContent).trim()
        : String(cat?.text || '').trim();
}

function getCurrentDateTime(timestamp) {
    const now = new Date(timestamp * 1000);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');
    const minute = String(now.getMinutes()).padStart(2, '0');
    const second = String(now.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
}

function fillCurrentDateTime() {
    const dateNow = new Date();
    var day = ('0' + dateNow.getDate()).slice(-2);
    var month = ('0' + (dateNow.getMonth() + 1)).slice(-2);
    var year = dateNow.getFullYear();
    var formattedDate = day + '/' + month + '/' + year;

    var hour = ('0' + dateNow.getHours()).slice(-2);
    var minutes = ('0' + dateNow.getMinutes()).slice(-2);
    var seconds = ('0' + dateNow.getSeconds()).slice(-2);
    var formattedHour = hour + ':' + minutes + ':' + seconds;

    setTimeout(() => {
        const d1 = document.getElementById('event-start-date');
        const t1 = document.getElementById('event-start-time');
        if (d1) d1.value = formattedDate;
        if (t1) t1.value = formattedHour;
    }, 1000);
}

function isValidUrl(string) {
    try {
        new URL(string);
        return true;
    } catch (e) {
        return false;
    }
}
